import React, { createContext, useContext, useState, useRef, useEffect } from 'react';
import theme from '@totallymoney/ui/theme';
import styled, { ThemeProvider } from 'styled-components';
import { focusStyles, focusOutlineStyle } from '@totallymoney/ui/styles/focus';
import ChevronDownIcon from '@totallymoney/ui/icons/ChevronDown';
import Box from '@totallymoney/ui/components/Box';
import { Basin } from '@mediaingenuity/basin-sls/client';
import LinkButton from '@totallymoney/ui/components/LinkButton';
import totallyMoneyTheme from '@totallymoney/ui/theme/TotallyMoneyTheme';
import Anchor from '@totallymoney/ui/components/Anchor';
import Heading from '@totallymoney/ui/components/Heading';
import Modal from '@totallymoney/ui/components/Modal';
import Text from '@totallymoney/ui/components/Text';
import PadlockIcon from '@totallymoney/ui/icons/Padlock';
import buttonStyles from '@totallymoney/ui/styles/button';
import TotallyMoneyWithSymbol from '@totallymoney/ui/brandassets/logos/TotallyMoneyWithSymbol';
import Grid$1 from '@totallymoney/ui/components/Grid';
import Button from '@totallymoney/ui/components/Button';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var Instagram = function Instagram(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      _c = _a.color;
      _c === void 0 ? theme.indigo100 : _c;
      var _d = _a.accessibleTitle,
      accessibleTitle = _d === void 0 ? 'Instagram' : _d,
      _e = _a.role,
      role = _e === void 0 ? 'img' : _e,
      otherProps = __rest(_a, ["size", "color", "accessibleTitle", "role"]);

  return /*#__PURE__*/React.createElement("svg", __assign({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": accessibleTitle,
    role: role
  }, otherProps), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6520_17479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.0301 0.0839251C5.7533 0.144165 4.88138 0.347925 4.11914 0.647445C3.33026 0.954885 2.66162 1.36745 1.99634 2.03513C1.33106 2.70281 0.921379 3.37193 0.616099 4.16201C0.320659 4.92593 0.120499 5.79857 0.0640995 7.07609C0.00769946 8.35361 -0.00478054 8.76425 0.00145946 12.023C0.00769946 15.2817 0.0220995 15.6902 0.0840195 16.9703C0.144979 18.2469 0.348019 19.1186 0.647539 19.881C0.955459 20.6699 1.36754 21.3383 2.03546 22.0038C2.70338 22.6694 3.37202 23.0781 4.16402 23.3838C4.92722 23.6788 5.8001 23.8799 7.07738 23.9358C8.35466 23.9918 8.76578 24.0047 12.0235 23.9985C15.2813 23.9922 15.6915 23.9778 16.9714 23.9171C18.2513 23.8564 19.1184 23.6519 19.8811 23.3538C20.67 23.0452 21.3389 22.6338 22.0039 21.9657C22.669 21.2975 23.0784 20.6279 23.3835 19.8374C23.6791 19.0742 23.88 18.2013 23.9355 16.925C23.9914 15.6441 24.0046 15.2351 23.9983 11.9769C23.9921 8.71865 23.9775 8.31017 23.9167 7.03049C23.856 5.75081 23.6527 4.88177 23.3535 4.11881C23.0451 3.32993 22.6335 2.66201 21.9658 1.99601C21.2981 1.33001 20.628 0.920805 19.8377 0.616485C19.074 0.321045 18.2016 0.119685 16.9243 0.0644851C15.6471 0.00928514 15.2359 -0.00487487 11.977 0.00136513C8.71802 0.00760513 8.31002 0.0215251 7.0301 0.0839251ZM7.17026 21.777C6.00026 21.7262 5.36498 21.5318 4.94162 21.369C4.38098 21.153 3.98162 20.8919 3.5597 20.4741C3.13778 20.0562 2.87858 19.6554 2.6597 19.096C2.4953 18.6726 2.2973 18.0381 2.24258 16.8681C2.18306 15.6035 2.17058 15.2238 2.16362 12.0201C2.15666 8.81633 2.1689 8.43713 2.22434 7.17209C2.27426 6.00305 2.46986 5.36705 2.63234 4.94393C2.84834 4.38257 3.1085 3.98393 3.5273 3.56225C3.9461 3.14057 4.3457 2.88089 4.90562 2.66201C5.3285 2.49689 5.96306 2.30057 7.13258 2.24489C8.3981 2.18489 8.7773 2.17289 11.9806 2.16593C15.1839 2.15897 15.564 2.17097 16.83 2.22665C17.9991 2.27753 18.6353 2.47121 19.0579 2.63465C19.6188 2.85065 20.0179 3.11009 20.4396 3.52961C20.8613 3.94913 21.1212 4.34729 21.3401 4.90841C21.5055 5.33009 21.7018 5.96441 21.757 7.13465C21.8172 8.40017 21.8309 8.77961 21.8367 11.9826C21.8424 15.1857 21.8311 15.5661 21.7757 16.8306C21.7246 18.0006 21.5307 18.6362 21.3677 19.06C21.1517 19.6204 20.8913 20.02 20.4723 20.4414C20.0532 20.8629 19.6541 21.1226 19.0939 21.3414C18.6715 21.5063 18.0363 21.7031 16.8677 21.7588C15.6022 21.8183 15.223 21.8308 12.0185 21.8378C8.81402 21.8447 8.43602 21.8318 7.1705 21.777M16.9529 5.58641C16.9534 5.87123 17.0383 6.14952 17.197 6.38607C17.3556 6.62262 17.5808 6.80681 17.8442 6.91535C18.1075 7.02389 18.3971 7.05189 18.6764 6.99583C18.9556 6.93976 19.212 6.80214 19.413 6.60037C19.614 6.3986 19.7507 6.14174 19.8058 5.86228C19.8608 5.58283 19.8317 5.29333 19.7222 5.03039C19.6127 4.76746 19.4277 4.5429 19.1906 4.38512C18.9534 4.22735 18.6748 4.14344 18.39 4.14401C18.0082 4.14477 17.6423 4.29715 17.3728 4.56764C17.1033 4.83813 16.9523 5.20458 16.9529 5.58641ZM5.8385 12.0119C5.84522 15.4151 8.60906 18.1677 12.0115 18.1612C15.414 18.1547 18.1685 15.3911 18.162 11.9879C18.1555 8.58473 15.391 5.83145 11.988 5.83817C8.58506 5.84489 5.83202 8.60921 5.8385 12.0119ZM7.99994 12.0076C7.99837 11.2165 8.23145 10.4426 8.66968 9.78395C9.10791 9.12527 9.73162 8.61134 10.4619 8.30714C11.1923 8.00294 11.9964 7.92213 12.7726 8.07494C13.5489 8.22774 14.2624 8.6073 14.8229 9.16561C15.3834 9.72393 15.7658 10.4359 15.9217 11.2115C16.0776 11.9872 15.9999 12.7916 15.6986 13.5231C15.3973 14.2547 14.8859 14.8804 14.2289 15.3212C13.572 15.7621 12.7991 15.9982 12.0079 15.9998C11.4826 16.0009 10.9622 15.8985 10.4765 15.6984C9.99076 15.4984 9.54918 15.2046 9.17699 14.8339C8.8048 14.4632 8.50929 14.0228 8.30733 13.5378C8.10537 13.0529 8.00092 12.5329 7.99994 12.0076Z",
    fill: "#0F0A3A"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6520_17479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

var LinkedIn = function LinkedIn(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 16 : _b,
      _c = _a.color,
      color = _c === void 0 ? theme.indigo100 : _c,
      _d = _a.accessibleTitle,
      accessibleTitle = _d === void 0 ? 'LinkedIn' : _d,
      _e = _a.role,
      role = _e === void 0 ? 'img' : _e,
      otherProps = __rest(_a, ["size", "color", "accessibleTitle", "role"]);

  return /*#__PURE__*/React.createElement("svg", __assign({
    width: size,
    height: size,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": accessibleTitle,
    role: role
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4286 22C20.8542 22 21.2225 21.8445 21.5335 21.5335C21.8445 21.2225 22 20.8542 22 20.4286V1.57143C22 1.14583 21.8445 0.77753 21.5335 0.466518C21.2225 0.155506 20.8542 0 20.4286 0H1.57143C1.14583 0 0.77753 0.155506 0.466518 0.466518C0.155506 0.77753 0 1.14583 0 1.57143V20.4286C0 20.8542 0.155506 21.2225 0.466518 21.5335C0.77753 21.8445 1.14583 22 1.57143 22H20.4286ZM5.00893 6.92411C4.48512 6.92411 4.04315 6.73586 3.68304 6.35938C3.32292 5.98289 3.14286 5.54092 3.14286 5.03348C3.14286 4.52604 3.32292 4.08408 3.68304 3.70759C4.04315 3.3311 4.48512 3.14286 5.00893 3.14286C5.53274 3.14286 5.98289 3.3311 6.35938 3.70759C6.73586 4.08408 6.92411 4.52604 6.92411 5.03348C6.92411 5.54092 6.73586 5.98289 6.35938 6.35938C5.98289 6.73586 5.53274 6.92411 5.00893 6.92411ZM11.933 18.8571H8.69196V8.34821H11.8348V9.77232H11.8839C12.1131 9.31399 12.4732 8.9375 12.9643 8.64286C13.5536 8.28274 14.2247 8.10268 14.9777 8.10268C16.4836 8.10268 17.5476 8.57738 18.1696 9.52679C18.628 10.2798 18.8571 11.4747 18.8571 13.1116V18.8571H15.6161V13.75C15.6161 12.8988 15.5342 12.2768 15.3705 11.8839C15.1414 11.2619 14.6503 10.9509 13.8973 10.9509C13.1443 10.9509 12.6042 11.2292 12.2768 11.7857C12.0476 12.2113 11.933 12.8333 11.933 13.6518V18.8571ZM6.67857 18.8571H3.38839V8.34821H6.67857V18.8571Z",
    fill: color
  }));
};

var TikTok = function TikTok(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      _c = _a.color;
      _c === void 0 ? theme.indigo100 : _c;
      var _d = _a.accessibleTitle,
      accessibleTitle = _d === void 0 ? 'TikTok' : _d,
      _e = _a.role,
      role = _e === void 0 ? 'img' : _e,
      otherProps = __rest(_a, ["size", "color", "accessibleTitle", "role"]);

  return /*#__PURE__*/React.createElement("svg", __assign({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": accessibleTitle,
    role: role
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.8639 4.80801C18.5652 3.96661 17.6324 2.61636 17.3389 1.04574C17.2746 0.705175 17.2424 0.356594 17.2424 0H13.1011L13.0931 16.5356C13.0247 18.3866 11.4928 19.8731 9.61918 19.8731C9.03619 19.8731 8.48937 19.7289 8.00689 19.4765C6.89719 18.8955 6.1413 17.7376 6.1413 16.4073C6.1413 14.4962 7.70132 12.9376 9.62321 12.9376C9.98105 12.9376 10.3268 12.9977 10.6485 13.0978V9.86444V8.8828C10.3107 8.83873 9.96898 8.80668 9.62321 8.80668C5.41758 8.81068 2 12.2164 2 16.4033C2 18.9716 3.28662 21.2474 5.25273 22.6217C6.4911 23.4871 7.99483 23.996 9.61918 23.996C13.8208 23.996 17.2384 20.5903 17.2384 16.4033V8.01736C18.8627 9.1793 20.853 9.86444 23 9.86444V6.6591V5.74157C21.842 5.73756 20.7645 5.397 19.8639 4.80801Z",
    fill: "#0F0A3A"
  }));
};

var YouTube = function YouTube(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 16 : _b,
      _c = _a.color,
      color = _c === void 0 ? theme.indigo100 : _c,
      _d = _a.accessibleTitle,
      accessibleTitle = _d === void 0 ? 'YouTube' : _d,
      _e = _a.role,
      role = _e === void 0 ? 'img' : _e,
      otherProps = __rest(_a, ["size", "color", "accessibleTitle", "role"]);

  return /*#__PURE__*/React.createElement("svg", __assign({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": accessibleTitle,
    role: role
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21L16 20.9557C18.8132 20.8672 20.6007 20.7196 21.3626 20.513C21.8901 20.3655 22.3443 20.0998 22.7253 19.7161C23.1062 19.3325 23.37 18.8898 23.5165 18.388C23.7216 17.5911 23.8681 16.3663 23.956 14.7135L24 12.5L23.956 10.2865C23.8681 8.66319 23.7216 7.45312 23.5165 6.65625C23.37 6.125 23.1062 5.66753 22.7253 5.28385C22.3443 4.90017 21.8901 4.63455 21.3626 4.48698C20.6007 4.28038 18.8132 4.13281 16 4.04427L12 4L8 4.04427C5.18681 4.13281 3.39927 4.28038 2.63736 4.48698C2.10989 4.63455 1.65568 4.90017 1.27473 5.28385C0.893773 5.66753 0.630036 6.125 0.483516 6.65625C0.278388 7.45312 0.131868 8.66319 0.043956 10.2865C0.0146518 11.1128 0 11.8507 0 12.5L0.043956 14.7135C0.131868 16.3663 0.278388 17.5911 0.483516 18.388C0.630036 18.8898 0.893773 19.3325 1.27473 19.7161C1.65568 20.0998 2.10989 20.3655 2.63736 20.513C3.39927 20.7196 5.18681 20.8672 8 20.9557L12 21ZM9.6 16.1429V8.85714L15.6 12.4777L9.6 16.1429Z",
    fill: color
  }));
};

var AppStore = function AppStore() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "40",
    viewBox: "0 0 120 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.443 0H9.55708C9.19605 0 8.83503 0 8.46398 0C8.1531 0 7.85225 0.01 7.54137 0.01C6.86946 0.03 6.19756 0.07 5.53568 0.19C4.86378 0.31 4.24202 0.51 3.63029 0.82C3.02858 1.12 2.47702 1.52 2.00568 2C1.52432 2.47 1.12318 3.02 0.82233 3.62C0.511449 4.23 0.310881 4.85 0.19054 5.52C0.0701989 6.18 0.0300852 6.85 0.0100284 7.52C0.0100284 7.83 0 8.14 0 8.44C0 8.8 0 9.17 0 9.53V30.46C0 30.83 0 31.19 0 31.55C0 31.86 0.0100284 32.16 0.0200568 32.47C0.0401137 33.14 0.0802273 33.81 0.200568 34.47C0.320909 35.14 0.511449 35.77 0.832358 36.37C1.13321 36.97 1.53435 37.51 2.01571 37.98C2.48705 38.46 3.03861 38.86 3.64031 39.16C4.25205 39.47 4.87381 39.67 5.54571 39.79C6.20759 39.91 6.88952 39.95 7.5514 39.97C7.85225 39.99 8.1531 40 8.46398 40C8.83503 40 9.19605 40 9.55708 40H110.443C110.804 40 111.165 40 111.526 40C111.827 40 112.148 40 112.449 39.99C113.12 39.97 113.792 39.93 114.454 39.81C115.126 39.69 115.748 39.49 116.37 39.18C116.971 38.88 117.513 38.48 117.994 38C118.476 37.53 118.867 36.98 119.178 36.39C119.489 35.78 119.689 35.16 119.799 34.49C119.92 33.83 119.96 33.16 119.99 32.49C119.99 32.18 119.99 31.88 119.99 31.57C120 31.21 120 30.85 120 30.48V9.54C120 9.17 120 8.81 119.99 8.45C119.99 8.14 119.99 7.84 119.99 7.53C119.97 6.86 119.93 6.19 119.799 5.53C119.689 4.86 119.489 4.24 119.178 3.63C118.867 3.03 118.466 2.48 117.994 2.01C117.523 1.54 116.971 1.14 116.37 0.83C115.748 0.52 115.126 0.32 114.454 0.2C113.792 0.08 113.12 0.04 112.449 0.02C112.148 0.02 111.827 0.01 111.526 0.01C111.175 0 110.804 0 110.443 0Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46407 39.12C8.16321 39.12 7.86236 39.12 7.56151 39.11C6.99992 39.09 6.33804 39.06 5.6862 38.95C5.07446 38.84 4.53293 38.66 4.02148 38.4C3.5 38.14 3.02867 37.79 2.6175 37.38C2.20634 36.97 1.86537 36.51 1.5946 35.98C1.33387 35.48 1.15335 34.93 1.05307 34.32C0.932729 33.65 0.902644 32.96 0.882587 32.44C0.872559 32.23 0.872559 31.53 0.872559 31.53V8.44C0.872559 8.44 0.882587 7.75 0.882587 7.55C0.902644 7.03 0.932729 6.34 1.05307 5.68C1.16338 5.06 1.34389 4.52 1.60463 4.02C1.8754 3.5 2.21637 3.03 2.62753 2.62C3.0387 2.2 3.51003 1.86 4.02148 1.6C4.53293 1.34 5.08449 1.16 5.67617 1.06C6.3581 0.930005 7.04003 0.900005 7.56151 0.890005L8.46407 0.880005H111.526L112.439 0.890005C112.95 0.900005 113.642 0.930005 114.304 1.05C114.906 1.16 115.457 1.33 115.979 1.6C116.49 1.86 116.961 2.21 117.373 2.62C117.784 3.03 118.125 3.5 118.396 4.02C118.656 4.53 118.827 5.07 118.937 5.67C119.057 6.3 119.087 6.95 119.108 7.56C119.108 7.84 119.108 8.15 119.108 8.45C119.118 8.83 119.118 9.18001 119.118 9.54V30.47C119.118 30.83 119.118 31.19 119.108 31.55C119.108 31.88 119.108 32.17 119.108 32.48C119.087 33.07 119.047 33.72 118.937 34.33C118.837 34.94 118.656 35.49 118.396 36C118.125 36.52 117.784 36.99 117.373 37.39C116.961 37.81 116.49 38.15 115.969 38.41C115.447 38.67 114.916 38.85 114.294 38.96C113.652 39.08 112.99 39.11 112.419 39.12C112.128 39.13 111.817 39.13 111.516 39.13H110.433L8.46407 39.12Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8403 20.3C24.8102 17.55 27.0967 16.21 27.207 16.15C25.9134 14.27 23.9077 14.01 23.2057 13.99C21.5209 13.81 19.8863 14.99 19.0339 14.99C18.1614 14.99 16.8376 14 15.4136 14.03C13.5784 14.06 11.8636 15.12 10.9309 16.76C8.99543 20.11 10.4395 25.03 12.2948 27.74C13.2274 29.07 14.3105 30.55 15.7345 30.49C17.1285 30.43 17.6499 29.61 19.3247 29.61C20.9894 29.61 21.4708 30.49 22.9249 30.46C24.4191 30.44 25.3618 29.13 26.2543 27.79C27.3274 26.27 27.7586 24.77 27.7786 24.7C27.7285 24.69 24.8704 23.6 24.8403 20.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1027 12.21C22.8548 11.28 23.3663 10.01 23.2158 8.71997C22.1328 8.76997 20.7789 9.46997 19.9967 10.38C19.3048 11.18 18.693 12.5 18.8535 13.74C20.0669 13.83 21.3205 13.13 22.1027 12.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4202 27.14H37.6768L36.5335 30.5H34.5278L39.0206 18.08H41.1065L45.5992 30.5H43.5534L42.4202 27.14ZM38.1681 25.59H41.9288L40.0735 20.14H40.0234L38.1681 25.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3167 25.97C55.3167 28.78 53.8024 30.59 51.5259 30.59C50.2323 30.59 49.2094 30.01 48.6678 29.01H48.6277V33.49H46.7625V21.44H48.5676V22.95H48.5976C49.1191 21.98 50.2223 21.35 51.4858 21.35C53.8024 21.35 55.3167 23.16 55.3167 25.97ZM53.4013 25.97C53.4013 24.14 52.4486 22.93 51.0045 22.93C49.5804 22.93 48.6177 24.16 48.6177 25.97C48.6177 27.79 49.5804 29.02 51.0045 29.02C52.4486 29.02 53.4013 27.82 53.4013 25.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.305 25.97C65.305 28.78 63.7907 30.59 61.5142 30.59C60.2205 30.59 59.1976 30.01 58.6561 29.01H58.616V33.49H56.7607V21.44H58.5659V22.95H58.5959C59.1174 21.98 60.2205 21.35 61.4841 21.35C63.7907 21.35 65.305 23.16 65.305 25.97ZM63.3895 25.97C63.3895 24.14 62.4368 22.93 60.9927 22.93C59.5687 22.93 58.606 24.16 58.606 25.97C58.606 27.79 59.5687 29.02 60.9927 29.02C62.4469 29.02 63.3895 27.82 63.3895 25.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9137 27.04C72.0541 28.27 73.2475 29.08 74.8921 29.08C76.4666 29.08 77.5898 28.27 77.5898 27.16C77.5898 26.2 76.9079 25.62 75.2933 25.22L73.6787 24.83C71.3922 24.28 70.3292 23.21 70.3292 21.48C70.3292 19.34 72.2045 17.87 74.8621 17.87C77.4895 17.87 79.2946 19.34 79.3548 21.48H77.4694C77.3591 20.24 76.3262 19.49 74.832 19.49C73.3377 19.49 72.3048 20.25 72.3048 21.35C72.3048 22.23 72.9567 22.74 74.5612 23.14L75.9351 23.48C78.4923 24.08 79.5554 25.11 79.5554 26.92C79.5554 29.24 77.7001 30.7 74.7517 30.7C71.9939 30.7 70.1286 29.28 70.0083 27.03H71.9137V27.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5868 19.3V21.4401H85.3116V22.91H83.5868V27.9C83.5868 28.68 83.9277 29.0401 84.6899 29.0401C84.8804 29.0401 85.1813 29.01 85.3016 29V30.46C85.091 30.51 84.6798 30.55 84.2687 30.55C82.4335 30.55 81.7114 29.8601 81.7114 28.1101V22.92H80.3877V21.4501H81.7114V19.3H83.5868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3044 25.97C86.3044 23.12 87.9892 21.33 90.6066 21.33C93.2341 21.33 94.9088 23.12 94.9088 25.97C94.9088 28.83 93.2441 30.61 90.6066 30.61C87.9792 30.61 86.3044 28.83 86.3044 25.97ZM93.0235 25.97C93.0235 24.02 92.1209 22.86 90.6167 22.86C89.1124 22.86 88.2098 24.02 88.2098 25.97C88.2098 27.93 89.1024 29.08 90.6167 29.08C92.131 29.08 93.0235 27.93 93.0235 25.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4634 21.44H98.2384V22.98H98.2785C98.5593 21.96 99.3917 21.34 100.465 21.34C100.735 21.34 100.956 21.38 101.107 21.41V23.15C100.956 23.09 100.635 23.04 100.274 23.04C99.0708 23.04 98.3287 23.85 98.3287 25.12V30.49H96.4634V21.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.691 27.84C109.44 29.48 107.836 30.61 105.78 30.61C103.142 30.61 101.498 28.85 101.498 26.01C101.498 23.17 103.142 21.33 105.699 21.33C108.207 21.33 109.791 23.05 109.791 25.8V26.44H103.383V26.55C103.383 28.1 104.356 29.11 105.83 29.11C106.863 29.11 107.675 28.62 107.926 27.84H109.691ZM103.393 25.13H107.936C107.896 23.74 107.003 22.83 105.709 22.83C104.426 22.84 103.493 23.77 103.393 25.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9374 8.72998C39.7124 8.72998 40.7554 9.81998 40.7554 11.69C40.7554 13.6 39.7224 14.69 37.9374 14.69H35.7712V8.72998H37.9374ZM36.7039 13.85H37.8271C39.0806 13.85 39.8027 13.07 39.8027 11.7C39.8027 10.35 39.0706 9.56998 37.8271 9.56998H36.7039V13.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7983 12.44C41.7983 10.99 42.6106 10.1 43.9244 10.1C45.2381 10.1 46.0504 10.98 46.0504 12.44C46.0504 13.9 45.2381 14.78 43.9244 14.78C42.6106 14.78 41.7983 13.9 41.7983 12.44ZM45.1378 12.44C45.1378 11.46 44.6965 10.89 43.9244 10.89C43.1522 10.89 42.7109 11.46 42.7109 12.44C42.7109 13.42 43.1421 13.99 43.9244 13.99C44.7066 13.99 45.1378 13.42 45.1378 12.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7164 14.7H50.7937L49.8611 11.38H49.7909L48.8583 14.7H47.9457L46.7021 10.2H47.6047L48.417 13.64H48.4872L49.4198 10.2H50.2723L51.2049 13.64H51.2751L52.0774 10.2H52.9699L51.7164 14.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0029 10.19H54.8654V10.91H54.9356C55.1562 10.41 55.6075 10.11 56.2794 10.11C57.2822 10.11 57.8438 10.71 57.8438 11.78V14.7H56.9513V12.01C56.9513 11.29 56.6404 10.93 55.9785 10.93C55.3167 10.93 54.8955 11.37 54.8955 12.07V14.7H54.0029V10.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2578 8.43994H60.1503V14.6999H59.2578V8.43994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3938 12.44C61.3938 10.99 62.2061 10.1 63.5198 10.1C64.8335 10.1 65.6458 10.98 65.6458 12.44C65.6458 13.9 64.8335 14.78 63.5198 14.78C62.1961 14.78 61.3938 13.9 61.3938 12.44ZM64.7333 12.44C64.7333 11.46 64.292 10.89 63.5198 10.89C62.7476 10.89 62.3064 11.46 62.3064 12.44C62.3064 13.42 62.7376 13.99 63.5198 13.99C64.292 13.99 64.7333 13.42 64.7333 12.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5886 13.42C66.5886 12.61 67.1903 12.14 68.2634 12.08L69.4868 12.01V11.62C69.4868 11.14 69.176 10.88 68.5642 10.88C68.0628 10.88 67.7218 11.06 67.6215 11.38H66.7591C66.8494 10.61 67.5814 10.11 68.6043 10.11C69.7375 10.11 70.3794 10.67 70.3794 11.62V14.7H69.5169V14.07H69.4467C69.176 14.52 68.6846 14.78 68.0929 14.78C67.2204 14.77 66.5886 14.25 66.5886 13.42ZM69.4969 13.04V12.66L68.3937 12.73C67.772 12.77 67.4912 12.98 67.4912 13.38C67.4912 13.79 67.8422 14.02 68.3235 14.02C68.9954 14.02 69.4969 13.6 69.4969 13.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5527 12.4399C71.5527 11.0199 72.2848 10.1199 73.4281 10.1199C74.0498 10.1199 74.5713 10.4099 74.812 10.9099H74.8822V8.43994H75.7747V14.6999H74.9123V13.9899H74.8421C74.5713 14.4799 74.0498 14.7799 73.4281 14.7799C72.2748 14.7699 71.5527 13.8699 71.5527 12.4399ZM72.4753 12.4399C72.4753 13.3999 72.9266 13.9699 73.6788 13.9699C74.4309 13.9699 74.8922 13.3899 74.8922 12.4399C74.8922 11.4999 74.4209 10.9099 73.6788 10.9099C72.9266 10.9199 72.4753 11.4999 72.4753 12.4399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4551 12.44C79.4551 10.99 80.2674 10.1 81.5811 10.1C82.8948 10.1 83.7071 10.98 83.7071 12.44C83.7071 13.9 82.8948 14.78 81.5811 14.78C80.2674 14.78 79.4551 13.9 79.4551 12.44ZM82.7945 12.44C82.7945 11.46 82.3533 10.89 81.5811 10.89C80.8089 10.89 80.3677 11.46 80.3677 12.44C80.3677 13.42 80.7989 13.99 81.5811 13.99C82.3533 13.99 82.7945 13.42 82.7945 12.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9104 10.19H85.7728V10.91H85.843C86.0637 10.41 86.515 10.11 87.1869 10.11C88.1897 10.11 88.7513 10.71 88.7513 11.78V14.7H87.8588V12.01C87.8588 11.29 87.5479 10.93 86.886 10.93C86.2241 10.93 85.8029 11.37 85.8029 12.07V14.7H84.9104V10.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7857 9.06995V10.2099H94.7685V10.9599H93.7857V13.2799C93.7857 13.7499 93.9762 13.9599 94.4275 13.9599C94.5679 13.9599 94.6381 13.9499 94.7685 13.9399V14.6799C94.6281 14.6999 94.4576 14.7299 94.2871 14.7299C93.2943 14.7299 92.9032 14.3799 92.9032 13.5099V10.9699H92.1912V10.2199H92.9032V9.06995H93.7857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9719 8.43994H96.8544V10.9199H96.9246C97.1453 10.4199 97.6166 10.1099 98.2985 10.1099C99.2612 10.1099 99.8529 10.7199 99.8529 11.7899V14.6999H98.9604V12.0099C98.9604 11.2899 98.6295 10.9299 97.9977 10.9299C97.2656 10.9299 96.8645 11.3899 96.8645 12.0699V14.6999H95.9719V8.43994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.058 13.48C104.857 14.29 104.135 14.78 103.102 14.78C101.808 14.78 101.016 13.9 101.016 12.46C101.016 11.02 101.828 10.11 103.102 10.11C104.356 10.11 105.118 10.97 105.118 12.38V12.69H101.929V12.74C101.959 13.53 102.42 14.03 103.132 14.03C103.674 14.03 104.045 13.84 104.205 13.48H105.058ZM101.929 12.03H104.205C104.185 11.32 103.754 10.86 103.092 10.86C102.43 10.86 101.979 11.33 101.929 12.03Z",
    fill: "white"
  }));
};

var GooglePlay = function GooglePlay() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "135",
    height: "40",
    viewBox: "0 0 135 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 40H5C2.25 40 0 37.75 0 35V5C0 2.25 2.25 0 5 0H130C132.75 0 135 2.25 135 5V35C135 37.75 132.75 40 130 40Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 0.8C132.32 0.8 134.2 2.68 134.2 5V35C134.2 37.32 132.32 39.2 130 39.2H5C2.68 39.2 0.8 37.32 0.8 35V5C0.8 2.68 2.68 0.8 5 0.8H130ZM130 0H5C2.25 0 0 2.25 0 5V35C0 37.75 2.25 40 5 40H130C132.75 40 135 37.75 135 35V5C135 2.25 132.75 0 130 0Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4201 10.24C47.4201 11.08 47.1701 11.75 46.6701 12.24C46.1101 12.83 45.3701 13.13 44.4701 13.13C43.6001 13.13 42.8701 12.83 42.2601 12.23C41.6501 11.63 41.3501 10.88 41.3501 10C41.3501 9.11 41.6501 8.37 42.2601 7.77C42.8701 7.17 43.6001 6.87 44.4701 6.87C44.9001 6.87 45.3101 6.95 45.7001 7.12C46.0901 7.29 46.4001 7.51 46.6401 7.79L46.1101 8.31999C45.7101 7.84999 45.1701 7.61 44.4701 7.61C43.8401 7.61 43.2901 7.82999 42.8301 8.27999C42.3701 8.72 42.1401 9.3 42.1401 10.01C42.1401 10.72 42.3701 11.3 42.8301 11.74C43.2901 12.18 43.8401 12.41 44.4701 12.41C45.1401 12.41 45.7001 12.19 46.1501 11.74C46.4401 11.45 46.6101 11.04 46.6501 10.52H44.4701V9.79H47.3801C47.4001 9.95 47.4201 10.1 47.4201 10.24Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.03 7.74H49.3V9.64H51.76V10.36H49.3V12.26H52.03V13H48.53V7H52.03V7.74Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2801 13H54.5101V7.74H52.8301V7H56.9501V7.74H55.2701V13H55.2801Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9402 13V7H60.7102V13H59.9402Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1302 13H63.3602V7.74H61.6802V7H65.8002V7.74H64.1202V13H64.1302Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6101 12.22C73.0201 12.83 72.2901 13.13 71.4101 13.13C70.5301 13.13 69.8001 12.83 69.2101 12.22C68.6201 11.61 68.3301 10.87 68.3301 10C68.3301 9.13 68.6201 8.38 69.2101 7.78C69.8001 7.17 70.5301 6.87 71.4101 6.87C72.2801 6.87 73.0101 7.17 73.6101 7.78C74.2001 8.39 74.5001 9.13 74.5001 10C74.4901 10.88 74.2001 11.62 73.6101 12.22ZM69.7801 11.72C70.2201 12.17 70.7701 12.39 71.4101 12.39C72.0501 12.39 72.6001 12.17 73.0401 11.72C73.4801 11.27 73.7101 10.7 73.7101 10C73.7101 9.3 73.4901 8.73 73.0401 8.27999C72.6001 7.82999 72.0501 7.6 71.4101 7.6C70.7701 7.6 70.2201 7.82 69.7801 8.27C69.3401 8.73 69.1101 9.3 69.1101 10C69.1101 10.7 69.3401 11.27 69.7801 11.72Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5801 13V7H76.5201L79.4401 11.67H79.4701L79.4401 10.51V7H80.2101V13H79.4101L76.3601 8.11H76.3301L76.3601 9.27V13H75.5801Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.14 21.75C65.79 21.75 63.87 23.54 63.87 26C63.87 28.45 65.79 30.25 68.14 30.25C70.49 30.25 72.41 28.45 72.41 26C72.41 23.54 70.49 21.75 68.14 21.75ZM68.14 28.58C66.85 28.58 65.74 27.5201 65.74 26C65.74 24.47 66.85 23.42 68.14 23.42C69.43 23.42 70.54 24.47 70.54 26C70.54 27.5201 69.42 28.58 68.14 28.58ZM58.82 21.75C56.47 21.75 54.55 23.54 54.55 26C54.55 28.45 56.47 30.25 58.82 30.25C61.17 30.25 63.09 28.45 63.09 26C63.09 23.54 61.17 21.75 58.82 21.75ZM58.82 28.58C57.53 28.58 56.42 27.5201 56.42 26C56.42 24.47 57.53 23.42 58.82 23.42C60.11 23.42 61.22 24.47 61.22 26C61.22 27.5201 60.11 28.58 58.82 28.58ZM47.74 23.06V24.8601H52.06C51.93 25.8701 51.59 26.62 51.08 27.13C50.45 27.76 49.47 28.4501 47.75 28.4501C45.09 28.4501 43.01 26.31 43.01 23.65C43.01 20.99 45.09 18.85 47.75 18.85C49.18 18.85 50.23 19.41 51 20.14L52.27 18.8701C51.19 17.8401 49.76 17.05 47.74 17.05C44.1 17.05 41.04 20.01 41.04 23.66C41.04 27.3 44.1 30.2701 47.74 30.2701C49.71 30.2701 51.19 29.63 52.35 28.42C53.54 27.23 53.91 25.5501 53.91 24.2001C53.91 23.7801 53.88 23.39 53.81 23.07H47.74V23.06ZM93.05 24.46C92.7 23.51 91.62 21.75 89.41 21.75C87.22 21.75 85.4 23.47 85.4 26C85.4 28.38 87.2 30.25 89.62 30.25C91.57 30.25 92.7 29.0601 93.16 28.3701L91.71 27.4C91.23 28.11 90.57 28.58 89.62 28.58C88.67 28.58 87.99 28.1401 87.56 27.2901L93.25 24.9401L93.05 24.46ZM87.25 25.88C87.2 24.24 88.52 23.4 89.47 23.4C90.21 23.4 90.84 23.77 91.05 24.3L87.25 25.88ZM82.63 30H84.5V17.5H82.63V30ZM79.57 22.7001H79.5C79.08 22.2001 78.28 21.75 77.26 21.75C75.13 21.75 73.18 23.62 73.18 26.0201C73.18 28.4001 75.13 30.26 77.26 30.26C78.27 30.26 79.08 29.8101 79.5 29.2901H79.56V29.9C79.56 31.53 78.69 32.4001 77.29 32.4001C76.15 32.4001 75.44 31.58 75.15 30.89L73.52 31.57C73.99 32.7 75.23 34.0801 77.29 34.0801C79.48 34.0801 81.33 32.79 81.33 29.65V22.01H79.56V22.7001H79.57ZM77.42 28.58C76.13 28.58 75.05 27.5 75.05 26.0201C75.05 24.5201 76.13 23.43 77.42 23.43C78.69 23.43 79.69 24.5301 79.69 26.0201C79.7 27.5 78.7 28.58 77.42 28.58ZM101.81 17.5H97.34V30H99.21V25.26H101.82C103.89 25.26 105.92 23.76 105.92 21.38C105.92 19 103.87 17.5 101.81 17.5ZM101.85 23.5201H99.2V19.23H101.85C103.25 19.23 104.04 20.3901 104.04 21.3701C104.04 22.3501 103.25 23.5201 101.85 23.5201ZM113.39 21.73C112.04 21.73 110.64 22.33 110.06 23.64L111.72 24.33C112.07 23.64 112.73 23.41 113.42 23.41C114.39 23.41 115.37 23.9901 115.38 25.0201V25.15C115.04 24.96 114.32 24.67 113.43 24.67C111.64 24.67 109.83 25.65 109.83 27.48C109.83 29.15 111.29 30.23 112.93 30.23C114.18 30.23 114.88 29.67 115.31 29.01H115.37V29.98H117.17V25.1901C117.18 22.97 115.52 21.73 113.39 21.73ZM113.16 28.58C112.55 28.58 111.7 28.2701 111.7 27.5201C111.7 26.5601 112.76 26.1901 113.68 26.1901C114.5 26.1901 114.89 26.3701 115.38 26.6101C115.24 27.76 114.24 28.58 113.16 28.58ZM123.74 22L121.6 27.42H121.54L119.32 22H117.31L120.64 29.58L118.74 33.7901H120.69L125.82 22H123.74ZM106.94 30H108.81V17.5H106.94V30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paint0",
    d: "M10.44 7.53997C10.15 7.84997 9.97998 8.32997 9.97998 8.93997V31.06C9.97998 31.68 10.15 32.16 10.44 32.46L10.51 32.53L22.9 20.15V20V19.85L10.51 7.46997L10.44 7.53997Z",
    fill: "#00D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paint1",
    fill: "#FFCC00",
    d: "M27.0299 24.28L22.8999 20.15V20V19.85L27.0299 15.72L27.1199 15.77L32.0099 18.55C33.4099 19.34 33.4099 20.64 32.0099 21.44L27.1199 24.22L27.0299 24.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paint2",
    fill: "#FF3549",
    d: "M27.1199 24.23L22.8999 20L10.4399 32.46C10.8999 32.95 11.6599 33.01 12.5199 32.52L27.1199 24.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paint3",
    fill: "#00EF6B",
    d: "M27.1199 15.78L12.5099 7.47999C11.6499 6.98999 10.8899 7.04999 10.4299 7.53999L22.8999 20L27.1199 15.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.2",
    d: "M27.0299 24.13L12.5099 32.38C11.6999 32.84 10.9699 32.81 10.5099 32.39L10.4399 32.46L10.5099 32.53C10.9799 32.95 11.6999 32.98 12.5099 32.52L27.1199 24.22L27.0299 24.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.12",
    d: "M10.44 32.32C10.15 32.01 9.97998 31.53 9.97998 30.92V31.07C9.97998 31.69 10.15 32.17 10.44 32.47L10.51 32.4L10.44 32.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.12",
    d: "M32.01 21.3L27.02 24.13L27.11 24.22L32 21.44C32.7 21.04 33.05 20.52 33.05 20C33 20.47 32.65 20.94 32.01 21.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.25",
    d: "M12.51 7.61994L32.01 18.6999C32.64 19.0599 33 19.5199 33.06 19.9999C33.06 19.4799 32.71 18.9499 32.01 18.5599L12.51 7.47994C11.11 6.68994 9.96997 7.34994 9.96997 8.94994V9.09994C9.96997 7.48994 11.12 6.82994 12.51 7.61994Z",
    fill: "white"
  }));
};

var TransUnion = function TransUnion() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "144",
    height: "45",
    viewBox: "0 0 445 140",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.62 91a13.13 13.13 0 0 0-8.14-2.49 15.3 15.3 0 0 0-3.27.36 12.21 12.21 0 0 0-3 1.11 10.25 10.25 0 0 0-2.5 1.83 6.7 6.7 0 0 0-1.61 2.57A5.89 5.89 0 0 0 56.85 91a6.23 6.23 0 0 0-2.64-1.88 10.13 10.13 0 0 0-3.53-.58 17.65 17.65 0 0 0-3.92.44l.07 5.43a6.5 6.5 0 0 1 2.21.18 1.89 1.89 0 0 1 1.13.84 3.64 3.64 0 0 1 .4 1.47c0 .59.08 1.27.08 2v25.61h7.92v-20.38a8.71 8.71 0 0 1 .74-3.71 7.07 7.07 0 0 1 2-2.6 8.12 8.12 0 0 1 2.89-1.54 11.21 11.21 0 0 1 3.42-.52 12.51 12.51 0 0 1 5.71 1.36zM111.67 118.87a2.11 2.11 0 0 1-1.14-1 3.58 3.58 0 0 1-.4-1.62V91.73a41.11 41.11 0 0 0-7.13-2.39 32.5 32.5 0 0 0-7.41-.84 22.43 22.43 0 0 0-8 1.21 17.89 17.89 0 0 0-6.31 3.78 17.7 17.7 0 0 0-4.22 6 20.25 20.25 0 0 0-1.61 7.93 23.61 23.61 0 0 0 1 7 16.15 16.15 0 0 0 3 5.65 13.48 13.48 0 0 0 5 3.78 16.88 16.88 0 0 0 7 1.36 14.08 14.08 0 0 0 7.3-2 11.34 11.34 0 0 0 4.88-5.68 9 9 0 0 0 .88 4.36 5.72 5.72 0 0 0 2.35 2.35 7.41 7.41 0 0 0 3.3.81 17.83 17.83 0 0 0 3.74-.34V119a5.18 5.18 0 0 1-2.23-.13zm-9.28-12.11a14.26 14.26 0 0 1-2.46 8.11 7.83 7.83 0 0 1-6.78 3.19c-3.28 0-5.72-1-7.3-2.9a11.79 11.79 0 0 1-2.39-7.73 15.55 15.55 0 0 1 1-5.18 12.23 12.23 0 0 1 2.38-4 10.21 10.21 0 0 1 3.56-2.53 11.57 11.57 0 0 1 4.6-.84 21.65 21.65 0 0 1 3.63.33 15.83 15.83 0 0 1 3.78 1.14zM149.85 92.86a12.21 12.21 0 0 0-4.36-3.19 15.34 15.34 0 0 0-6.24-1.17 19.66 19.66 0 0 0-3.56.33 16.16 16.16 0 0 0-3.45 1 10.43 10.43 0 0 0-3 1.87 7.9 7.9 0 0 0-2.05 2.86 6.33 6.33 0 0 0-1-3.86 5.06 5.06 0 0 0-2.61-1.83 10 10 0 0 0-3.55-.36 29.31 29.31 0 0 0-3.89.47v5.5a8 8 0 0 1 2.09.11 1.82 1.82 0 0 1 1.14.74 3.13 3.13 0 0 1 .43 1.54c.06.66.08 1.5.08 2.53v25.09H128v-20.1a10.36 10.36 0 0 1 .7-3.89 9.09 9.09 0 0 1 1.9-3 8.73 8.73 0 0 1 6.35-2.64 8.48 8.48 0 0 1 6 2.39 8.39 8.39 0 0 1 2.31 6.49v20.76h8.07v-20.74a21 21 0 0 0-.84-6.09 13.32 13.32 0 0 0-2.64-4.81zM185.55 106.1a16 16 0 0 0-4.66-1.61c-1.75-.34-3.57-.63-5.43-.88a29.93 29.93 0 0 1-6.26-1.28 3.05 3.05 0 0 1-2.17-3 3.29 3.29 0 0 1 .52-2.09 4.58 4.58 0 0 1 1.65-1.55 9 9 0 0 1 2.38-1 11.11 11.11 0 0 1 2.71-.33 18.27 18.27 0 0 1 2.83.22 8.61 8.61 0 0 1 2.56.77 5.79 5.79 0 0 1 1.88 1.43 3.32 3.32 0 0 1 .73 2.2h7a8.43 8.43 0 0 0-1.1-4.62A10.18 10.18 0 0 0 185 91.1a15.59 15.59 0 0 0-4.85-2 24.85 24.85 0 0 0-5.83-.66 23.52 23.52 0 0 0-5.57.66 15 15 0 0 0-4.81 2.06 11.3 11.3 0 0 0-3.37 3.45 9 9 0 0 0-1.28 4.91 7.55 7.55 0 0 0 1.5 4.77 9.53 9.53 0 0 0 3.67 2.75 19.93 19.93 0 0 0 5 1.43q2.75.45 5.46.81a21.26 21.26 0 0 1 5.72 1.39 3.4 3.4 0 0 1 2.2 3.38 4.87 4.87 0 0 1-.84 2.68 5.4 5.4 0 0 1-2 1.65 10.13 10.13 0 0 1-2.68.84 17.15 17.15 0 0 1-2.93.26 13 13 0 0 1-2.87-.33 9.74 9.74 0 0 1-2.53-1 6.35 6.35 0 0 1-1.87-1.65 4.22 4.22 0 0 1-.8-2.39h-7.85a10.75 10.75 0 0 0 1.68 5.46 11.45 11.45 0 0 0 3.71 3.49 15.18 15.18 0 0 0 5.06 1.83 31.4 31.4 0 0 0 5.76.52 24.78 24.78 0 0 0 5.72-.66 15.76 15.76 0 0 0 4.92-2 10.92 10.92 0 0 0 3.45-3.48 9.52 9.52 0 0 0 1.31-5.07 9.16 9.16 0 0 0-1.24-5.06 9 9 0 0 0-3.29-3.04zM275.05 92.86a12.13 12.13 0 0 0-4.36-3.19 15.34 15.34 0 0 0-6.24-1.17 19.66 19.66 0 0 0-3.56.33 16.16 16.16 0 0 0-3.45 1 10.43 10.43 0 0 0-3 1.87 8 8 0 0 0-2.05 2.86 6.27 6.27 0 0 0-1-3.86 5.07 5.07 0 0 0-2.6-1.83 10.12 10.12 0 0 0-3.56-.36 29.31 29.31 0 0 0-3.89.47v5.5a7.62 7.62 0 0 1 2.09.11 1.76 1.76 0 0 1 1.14.74 3.24 3.24 0 0 1 .43 1.57c.05.66.07 1.5.07 2.53v25.09h8.07v-20.1a10.36 10.36 0 0 1 .7-3.89 9 9 0 0 1 1.91-3 8.51 8.51 0 0 1 2.82-1.94 8.68 8.68 0 0 1 3.52-.7 8.48 8.48 0 0 1 6 2.39 8.39 8.39 0 0 1 2.31 6.49v20.76h8.07v-20.77a21 21 0 0 0-.84-6.09 13.17 13.17 0 0 0-2.58-4.81zM289.15 73.53a5.34 5.34 0 0 0-3.34 1.18 4.18 4.18 0 0 0-1.5 3.52 4.36 4.36 0 0 0 1.54 3.63 5.06 5.06 0 0 0 3.38 1.14 5.5 5.5 0 0 0 3.23-1.25 5 5 0 0 0 0-7 5.2 5.2 0 0 0-3.31-1.22zM285.12 89.16h7.99v35.36h-7.99zM330.37 92.94a17.46 17.46 0 0 0-6.09-3.34 23.08 23.08 0 0 0-7.12-1.1 20.79 20.79 0 0 0-6.75 1.13 17.32 17.32 0 0 0-5.86 3.42 16.75 16.75 0 0 0-4.15 5.68 18.84 18.84 0 0 0-1.58 8 19.21 19.21 0 0 0 1.61 8.11 17.55 17.55 0 0 0 4.22 5.79 17.35 17.35 0 0 0 5.94 3.45 21.24 21.24 0 0 0 13.73 0 17.81 17.81 0 0 0 6-3.45 17.34 17.34 0 0 0 4.25-5.79 21.31 21.31 0 0 0 0-16.18 16 16 0 0 0-4.2-5.72zm-3.12 18.74a11 11 0 0 1-2.38 3.56 10 10 0 0 1-3.38 2.16 10.74 10.74 0 0 1-3.89.74 11.66 11.66 0 0 1-4-.7 10.09 10.09 0 0 1-5.94-5.72 12.86 12.86 0 0 1-.92-5 12.43 12.43 0 0 1 .89-4.88 9.64 9.64 0 0 1 2.37-3.47 9.9 9.9 0 0 1 3.33-2.06 12.44 12.44 0 0 1 3.85-.77 11.38 11.38 0 0 1 4 .59 9.82 9.82 0 0 1 3.52 2.05 10.27 10.27 0 0 1 2.49 3.52 12 12 0 0 1 1 5 12.56 12.56 0 0 1-.94 4.98z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.49 80.72v-7.55h38.15v7.55H35.75v43.8h-8.36v-43.8zM196.12 107.28V73.16h8.51v33.9c0 6.75 5.06 10.49 11.59 10.49s11.45-3.74 11.45-10.49v-33.9h8.43v34.12c0 11.44-8.95 17.9-19.88 17.9s-20.1-6.46-20.1-17.9zM375.8 116.23v-12.47a21 21 0 0 0-.84-6.09 13.32 13.32 0 0 0-2.57-4.81 12.08 12.08 0 0 0-4.39-3.19 15.29 15.29 0 0 0-6.23-1.17 19.57 19.57 0 0 0-3.56.33 16.16 16.16 0 0 0-3.45 1 10.43 10.43 0 0 0-3 1.87 7.9 7.9 0 0 0-2.05 2.86 6.33 6.33 0 0 0-1-3.86 5.1 5.1 0 0 0-2.61-1.83 10.1 10.1 0 0 0-3.56-.36 29.16 29.16 0 0 0-3.88.47v5.5a7.62 7.62 0 0 1 2.09.11 1.82 1.82 0 0 1 1.14.74 3.13 3.13 0 0 1 .43 1.54c.05.66.08 1.5.08 2.53v25.09h8.07v-20.1a10.56 10.56 0 0 1 .69-3.89 9.27 9.27 0 0 1 1.91-3 8.69 8.69 0 0 1 6.35-2.64 8.09 8.09 0 0 1 8.29 8.88v12.77c0 8.59 5.38 9.49 12.25 8.14v-5.16c-3.49.4-4.16-.57-4.16-3.26zM396.67 15.6a37 37 0 0 0-32.1 18.56c-2.44 4.43-2.66 8.27-.85 11.43 2.11 3.71 6.88 4.27 9.53 4.27H378l-1.71 5.36a10.24 10.24 0 0 0 1.06 9.07 8.9 8.9 0 0 0 7.46 3.53 15.82 15.82 0 0 0 6.6-1.34 12.37 12.37 0 0 1-1.41-2.65 12.78 12.78 0 0 1-.66-2.71 11.87 11.87 0 0 1-4.29.73 3.44 3.44 0 0 1-2.72-1.22 4.18 4.18 0 0 1-.35-3.56l2.34-7.21h7.28l1.92-6h-7.24l3.2-9.84h-6.38l-3.2 9.84h-6.64c-2.12 0-3.45-.54-4.08-1.65s-.08-3.78 1.68-6.77l.07-.12a31.06 31.06 0 1 1-4.74 23.14l-5.89 1.2a37.05 37.05 0 1 0 36.38-44z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.25 62.66a8.34 8.34 0 0 1-4.56-1 3.05 3.05 0 0 1-1.24-1.87v-.09a3.57 3.57 0 0 1 .19-1.71l4.58-14.11h-6.37l-3.91 12.21c-1.09 3.16-4.39 5.73-7.35 5.73a2.9 2.9 0 0 1-2.28-1A3 3 0 0 1 399 58l4.58-14.11h-6.37l-3.9 12.2a9.4 9.4 0 0 0 1 8.43 8.45 8.45 0 0 0 7.06 3.34 14 14 0 0 0 8.63-3.38 6.5 6.5 0 0 0 3.43 2.67 13.39 13.39 0 0 0 4.81.67 7.75 7.75 0 0 0 1.72-.23c.12-.2.26-.4.38-.6.23-.38.46-.77.67-1.16s.41-.79.61-1.19.37-.81.55-1.23.24-.58.35-.88a22.13 22.13 0 0 1-2.27.13zM384 120.39c0-6.37 9.47-6.37 9.47 0s-9.47 6.4-9.47 0zm8.65 0a3.91 3.91 0 1 0-7.81 0 3.91 3.91 0 1 0 7.81 0zm-1.8 2.18v.12h-.74l-1.19-1.61h-1v1.61h-.71v-4.58h1.87a1.49 1.49 0 0 1 1.63 1.5 1.34 1.34 0 0 1-1.08 1.37zm-2.92-2.08H389a.87.87 0 0 0 1-.88.89.89 0 0 0-1-.89h-1.11z"
  }));
};

var TmLogo = function TmLogo(_a) {
  var _b = _a.color,
      color = _b === void 0 ? '#fff' : _b;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 137 22",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "Totally Money Logo"), /*#__PURE__*/React.createElement("g", {
    id: "Signed-in-tm-log",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tm_logo_id",
    transform: "translate(-63.000000, -23.000000)",
    fill: color,
    "data-testid": "tm_logo_group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_svg",
    transform: "translate(63.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4465857,10.1858008 C12.4465857,12.2864593 13.8774156,13.8225012 15.8894881,13.8225012 C17.9240934,13.8225012 19.3547953,12.2864593 19.3547953,10.1858008 C19.3547953,8.08501294 17.9240934,6.54897107 15.8894881,6.54897107 C13.8774156,6.54897107 12.4465857,8.08501294 12.4465857,10.1858008 M21.7917895,10.2083079 C21.7917895,13.5965252 19.3325186,16.1716428 15.8894881,16.1716428 C12.4688624,16.1716428 10.0095915,13.5965252 10.0095915,10.2083079 C10.0095915,6.82009055 12.4688624,4.2451023 15.8894881,4.2451023 C19.3325186,4.2451023 21.7917895,6.82009055 21.7917895,10.2083079",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.852548,16.1290475 C68.852548,19.8333984 66.0578463,21.730976 63.240996,21.730976 C60.8486832,21.730976 58.3447309,20.375508 57.6741254,17.4616204 L60.0215007,16.6485207 C60.3792081,18.4104092 61.8101661,19.4268485 63.3527635,19.4268485 C64.9624472,19.4268485 66.4155538,18.3199929 66.4155538,16.1290475 L66.4155538,13.7771896 C65.767225,14.9066816 64.6494211,15.8103269 63.0397375,15.8103269 C60.9158974,15.8103269 58.568266,14.3420649 58.568266,11.0894073 L58.568266,4.53869003 L61.0499417,4.53869003 L61.0499417,10.7052352 C61.0499417,12.4444873 62.056106,13.3932761 63.4421264,13.3932761 C64.9848519,13.3932761 66.3710004,12.21877 66.3710004,10.0050588 L66.3710004,4.53869003 L68.852548,4.53869003 L68.852548,16.1290475 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0678447,13.8901776 C35.3910749,13.8901776 33.7588585,12.6703986 33.7588585,10.1858267 C33.7588585,7.65598189 35.4356283,6.48121707 37.0899934,6.48121707 C38.7892959,6.48121707 40.4883424,7.67848895 40.4883424,10.1631903 C40.4883424,12.6478916 38.7668912,13.8901776 37.0678447,13.8901776 M44.5702277,13.6671766 C44.3454122,13.7922589 44.0422443,13.8901776 43.7973286,13.8901776 C43.372535,13.8901776 42.96989,13.6418238 42.96989,12.8512312 L42.96989,4.5387547 L40.5328958,4.5387547 L40.5328958,5.93910748 C39.7503947,4.67405574 38.2527347,4.24512817 36.9558211,4.24512817 C34.1612474,4.24512817 31.2994596,6.21022695 31.2994596,10.2309701 C31.2994596,14.0935172 33.960245,16.1716686 36.6877325,16.1716686 C38.1856485,16.1716686 39.8400136,15.5392721 40.8013685,14.1839334 C41.1143945,15.5392721 42.2768798,16.1491616 43.372535,16.1491616 C44.0235523,16.1491616 44.6918533,15.9370261 45.2086984,15.4679998 C44.9093712,14.9350741 44.6913412,14.3321696 44.5702277,13.6671766",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.145375,13.7783796 C50.8108404,13.9131632 50.476818,13.980555 50.1646881,13.980555 C49.3600383,13.980555 48.7339862,13.5287324 48.7339862,12.2413029 L48.7339862,0.111293509 L46.2523106,0.111293509 L46.2523106,12.3768627 C46.2523106,15.0874106 47.9290804,16.1716298 49.7624272,16.1716298 C50.476818,16.1716298 51.211565,16.0007573 51.8867795,15.6822954 C51.5734973,15.1884337 51.2993915,14.5623754 51.145375,13.7783796",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6463622,10.1858008 C91.6463622,12.2864593 93.0771921,13.8225012 95.0893927,13.8225012 C97.12387,13.8225012 98.5546999,12.2864593 98.5546999,10.1858008 C98.5546999,8.08501294 97.12387,6.54897107 95.0893927,6.54897107 C93.0771921,6.54897107 91.6463622,8.08501294 91.6463622,10.1858008 M100.991694,10.2083079 C100.991694,13.5965252 98.5322951,16.1716428 95.0893927,16.1716428 C91.668767,16.1716428 89.2094961,13.5965252 89.2094961,10.2083079 C89.2094961,6.82009055 91.668767,4.2451023 95.0893927,4.2451023 C98.5322951,4.2451023 100.991694,6.82009055 100.991694,10.2083079",
    id: "Fill-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.318925,4.53869003 L104.755919,4.53869003 L104.755919,6.16501881 C105.583101,4.80968015 106.96925,4.2450635 108.332993,4.2450635 C110.412152,4.2450635 112.401948,5.64541627 112.401948,8.49165334 L112.401948,15.9231209 L109.9204,15.9231209 L109.9204,9.37253293 C109.9204,7.45244826 108.914236,6.63934854 107.639983,6.63934854 C106.097386,6.63934854 104.8006,7.83662041 104.8006,10.0276952 L104.8006,15.9231209 L102.318925,15.9231209 L102.318925,4.53869003 Z",
    id: "Fill-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.345001,9.25962253 L122.135535,9.25962253 C122.090725,7.38468133 120.794068,6.48116533 119.363238,6.48116533 C117.910003,6.48116533 116.546259,7.40744708 116.345001,9.25962253 M124.527719,11.3376446 L116.412087,11.3376446 C116.792071,13.1221696 118.222901,13.8224753 119.676264,13.8224753 C120.905835,13.8224753 122.068448,13.3255092 122.85095,12.2186536 L124.438228,13.7772025 C123.18638,15.3810242 121.464801,16.1717462 119.586773,16.1717462 C116.658027,16.1717462 113.729153,14.070829 113.729153,10.1631385 C113.729153,6.27795508 116.546259,4.24507643 119.475005,4.24507643 C122.224897,4.24507643 124.61721,6.07461548 124.61721,9.91465546 C124.61721,10.2986983 124.61721,10.7505209 124.527719,11.3376446",
    id: "Fill-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.214896,15.607039 C136.214896,19.3113899 133.420322,21.2089675 130.603216,21.2089675 C128.211031,21.2089675 125.707079,19.8534995 125.036345,16.9396119 L127.383848,16.1265122 C127.741556,17.8884008 129.172386,18.9048401 130.714983,18.9048401 C132.324795,18.9048401 133.77803,17.7979845 133.77803,15.607039 L133.77803,13.7772413 C133.129573,14.9067333 132.011769,15.8102493 130.402085,15.8102493 C128.278117,15.8102493 125.930614,14.3421167 125.930614,11.0893297 L125.930614,4.53874177 L128.412289,4.53874177 L128.412289,10.7051576 C128.412289,12.444539 129.418326,13.3933278 130.804474,13.3933278 C132.3472,13.3933278 133.73322,12.2186924 133.73322,10.0051105 L133.73322,4.53874177 L136.214896,4.53874177 L136.214896,15.607039 Z",
    id: "Fill-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0205162,0.111332314 L79.9231207,9.05620532 L74.8480018,0.111332314 L74.5573805,0.111332314 L71.9880064,0.111332314 L71.98647,0.111332314 L71.98647,12.2885548 C71.9703386,13.5063935 71.3610581,13.9560172 70.5689549,13.9785242 L70.5689549,16.1571813 C70.6872519,16.1657185 70.8052928,16.1716686 70.9228216,16.1716686 C71.4331373,16.1716686 71.9301382,16.0903069 72.3861704,15.9231856 C73.6273923,15.4685172 74.5573805,14.3589452 74.5573805,12.3769015 L74.5573805,4.96781162 L78.7605073,12.3769015 L81.1080107,12.3769015 L85.3110095,4.96781162 L85.3110095,15.9231856 L87.882176,15.9231856 L87.882176,0.111332314 L85.0205162,0.111332314 Z",
    id: "Fill-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3665661,13.8859349 C57.1425188,13.9472472 56.9215442,13.9806197 56.7111958,13.9806197 C55.906418,13.9806197 55.2803659,13.528797 55.2803659,12.2412382 L55.2803659,0.111358184 L52.7986903,0.111358184 L52.7986903,12.376798 C52.7986903,15.0874753 54.4755881,16.1716945 56.3088069,16.1716945 C57.0133395,16.1716945 57.7378444,16.0048318 58.4056333,15.6946484 C58.0171994,15.2160501 57.6463051,14.618837 57.3665661,13.8859349",
    id: "Fill-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1653195,13.6109995 C29.7115917,13.8276623 29.2423727,13.9806844 28.7918457,13.9806844 C27.9199817,13.9806844 27.2045668,13.506096 27.2045668,12.2413029 L27.2045668,6.84258467 L30.3569759,6.84258467 L30.3569759,6.50523754 L30.3569759,4.5387159 L27.2045668,4.5387159 L27.2045668,1.62469897 L24.7452959,1.62469897 L24.7452959,4.5387159 L22.3084297,4.5387159 L22.3084297,6.84258467 L24.7452959,6.84258467 L24.7452959,12.3767333 C24.7452959,14.9971237 26.5338332,16.1716298 28.456671,16.1716298 C29.3730883,16.1716298 30.3853979,15.8857643 31.2125804,15.3887982 L31.2089957,15.3823307 C30.7806173,14.8474647 30.4325119,14.2537441 30.1653195,13.6109995",
    id: "Fill-23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0.250079433 0.109857714 0.250079433 2.4816357 5.37000773 2.4816357 5.37000773 15.921711 7.94079015 15.921711 7.94079015 2.4816357 13.0607184 2.4816357 13.0607184 0.109857714"
  }))))));
};

var TmMenuMobileClose = function TmMenuMobileClose(_a) {
  var _b = _a.color,
      color = _b === void 0 ? '#fff' : _b;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M9.426 8l4.285 4.284a1 1 0 0 1 0 1.415l-.012.012a1 1 0 0 1-1.415 0L8 9.426l-4.284 4.285a1 1 0 0 1-1.415 0l-.012-.012a1 1 0 0 1 0-1.415L6.574 8 2.289 3.716a1 1 0 0 1 0-1.415l.012-.012a1 1 0 0 1 1.415 0L8 6.574l4.284-4.285a1 1 0 0 1 1.415 0l.012.012a1 1 0 0 1 0 1.415L9.426 8z"
  }));
};

var TmMenuMobileOpen = function TmMenuMobileOpen(_a) {
  var _b = _a.color,
      color = _b === void 0 ? '#fff' : _b;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M1 1h14a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2zm0 6h14a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2zm0 6h14a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2z"
  }));
};

var MenuWrapper = styled.button.withConfig({
  displayName: "styled-components__MenuWrapper",
  componentId: "sc-1k0ml5i-0"
})(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  margin-right: ", ";\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  padding: 0;\n\n  img {\n    width: 100%;\n  }\n\n  ", "\n"], ["\n  margin-right: ", ";\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  padding: 0;\n\n  img {\n    width: 100%;\n  }\n\n  ", "\n"])), theme.space20, theme.mediaLargePlus(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))));
var templateObject_1$h, templateObject_2$e;

function strEnum(o) {
  return o.reduce(function (res, key) {
    res[key] = key;
    return res;
  }, Object.create(null));
}

strEnum(['Privacy', 'T&Cs', 'Cookies', 'Help', 'Guides']);
var VARIANTS = strEnum(['loggedOut', 'loggedIn', 'secure', 'debitCardPage']);
var SECTION_HEADINGS = strEnum(['Services', 'Company', 'Guidance', 'Legal']);
var PLATFORM_NAMES = strEnum(['Instagram', 'LinkedIn', 'TikTok', 'YouTube', 'AppStore', 'GooglePlay']);

var MobileHamburgerButton = function MobileHamburgerButton(_a) {
  var isMenuOpen = _a.isMenuOpen,
      setIsMenuOpen = _a.setIsMenuOpen,
      variant = _a.variant;
  var color = variant === VARIANTS.loggedOut ? theme.indigo100 : '#fff';
  return /*#__PURE__*/React.createElement(MenuWrapper, {
    onClick: function onClick() {
      return setIsMenuOpen(!isMenuOpen);
    },
    "data-testid": isMenuOpen ? 'btn-opened' : 'btn-closed',
    "aria-label": "Main menu mobile button",
    type: "button",
    id: "menubutton",
    "aria-haspopup": "true",
    "aria-controls": "menu2"
  }, !isMenuOpen ? /*#__PURE__*/React.createElement(TmMenuMobileOpen, {
    color: color
  }) : /*#__PURE__*/React.createElement(TmMenuMobileClose, {
    color: color
  }));
};

MobileHamburgerButton.defaultProps = {
  isMenuOpen: false
};

var context = /*#__PURE__*/React.createContext({});

function isGuid(value) {
  if (!value) {
    return false;
  }

  var validator = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
  return validator.test(value.toString());
}

function isKeyValue(item) {
  return /.+=.+/.test(item);
}

function populateCookies() {
  // parse cookies to object
  var cookies = {};

  if (typeof window !== 'undefined') {
    document.cookie.split(';').forEach(function (item) {
      if (!isKeyValue(item)) {
        return;
      }

      cookies[item.split('=')[0].trim()] = item.split('=')[1];
    });
  }

  return cookies;
}

var startCase = function startCase(str) {
  return str.toLowerCase().split(' ').map(function (s) {
    return s.charAt(0).toUpperCase() + s.substring(1);
  }).join(' ');
};

var getStateVariant = function getStateVariant() {
  var cookies = populateCookies();

  if (isGuid(cookies.PulseSessionToken)) {
    return VARIANTS.loggedIn;
  }

  return VARIANTS.loggedOut;
};

function handleClickEvent(destination, title, basin) {
  var payload = {
    referrer: document.referrer,
    url: window.location.href,
    destination: destination,
    label: title,
    userAgent: navigator.userAgent
  };
  basin.send('Click', payload);
}

var KEY_NAMES = strEnum(['Tab', 'Shift', 'Escape', 'Esc', 'Enter', 'ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown']);

function hideDropDown() {
  var subMenusActive = [].slice.call(document.querySelectorAll('.tm-nav__menu--dropdown-active'));
  subMenusActive.map(function (subMenu) {
    subMenu.classList.remove('tm-nav__menu--dropdown-active');
  });
}

function getDropdown(link) {
  return link.nextElementSibling;
}

function getDropdownLinks(dropdown) {
  return [].slice.call(dropdown.querySelectorAll('a'));
}

function openDropDown(target) {
  var dropdown = target.nextElementSibling;
  var subLinks = getDropdownLinks(dropdown);
  subLinks.forEach(function (link) {
    link.setAttribute('tabindex', '0');
  });
  dropdown.classList.add('tm-nav__menu--dropdown-active');
}

function setPrimaryKeyboardControls(e, hasDropdown, keyName, menuItems) {
  if (keyName === void 0) {
    keyName = KEY_NAMES.Tab;
  }

  var nav = document.querySelector('.tm-nav');
  var menuItem = e.target;
  var firstItem = menuItems[0];
  var lastItem = menuItems[menuItems.length - 1];
  var dropDown = getDropdown(menuItem);
  var isAriaHidden = dropDown === null || dropDown === void 0 ? void 0 : dropDown.getAttribute('aria-hidden');

  switch (keyName) {
    case KEY_NAMES.Tab:
      {
        hideDropDown();

        if (hasDropdown) {
          openDropDown(menuItem);
        } // [TODO]
        // When last item it will get all the last item on the submenu
        // it will set the attributes to aria-hidden true and remove dropdown if still open


        if (menuItem === lastItem) {
          [].slice.call(nav.querySelectorAll('.tm-nav__menu--dropdown-active')).forEach(function (parent) {
            parent.setAttribute('aria-hidden', 'false');
            getDropdownLinks(parent).forEach(function (link) {
              link.setAttribute('tabindex', '-1');
            });
          });
        }

        break;
      }

    case KEY_NAMES.Enter:
      if (hasDropdown) {
        e.preventDefault();
        isAriaHidden === 'true' ? dropDown.setAttribute('aria-hidden', 'false') : dropDown.setAttribute('aria-hidden', 'true');
        openDropDown(menuItem);
      }

      break;

    case KEY_NAMES.Escape:
    case KEY_NAMES.Esc:
      e.preventDefault();
      hideDropDown();
      break;

    case KEY_NAMES.ArrowLeft:
      e.preventDefault();

      if (menuItem === firstItem) {
        lastItem.focus();
      } else {
        hideDropDown();
        menuItems[menuItems.indexOf(menuItem) - 1].focus();
      }

      break;

    case KEY_NAMES.ArrowRight:
      e.preventDefault();

      if (menuItem === lastItem) {
        firstItem.focus();
      } else {
        hideDropDown();
        menuItems[menuItems.indexOf(menuItem) + 1].focus();
      }

      break;

    case KEY_NAMES.ArrowUp:
      e.preventDefault();

      if (isAriaHidden === 'true') {
        return;
      }

      if (hasDropdown) {
        dropDown.setAttribute('aria-hidden', 'false');
        getDropdownLinks(getDropdown(menuItem)).forEach(function (link) {
          link.setAttribute('tabindex', '0');
        });
        window.setTimeout(function () {
          dropDown.lastElementChild.querySelector('a').focus();
        }, 0);
      }

      break;

    case KEY_NAMES.ArrowDown:
      e.preventDefault();

      if (isAriaHidden === 'true') {
        return;
      }

      if (hasDropdown) {
        dropDown.setAttribute('aria-hidden', 'false');
        getDropdownLinks(getDropdown(menuItem)).forEach(function (link) {
          link.setAttribute('tabindex', '0');
        });
        window.setTimeout(function () {
          dropDown.firstElementChild.querySelector('a').focus();
        }, 0);
      }

      break;
  }
}
function setSecondaryKeyboardControls(e) {
  var menuItem = e.target;
  var dropdown = menuItem.parentElement.parentElement;
  var dropdownTrigger = dropdown.parentElement.previousElementSibling;
  var dropdownLinks = getDropdownLinks(dropdown);
  var firstItem = dropdownLinks[0];
  var lastItem = dropdownLinks[dropdownLinks.length - 1];

  switch (e.key) {
    case KEY_NAMES.Tab:
      if (menuItem === lastItem) {
        hideDropDown();
        dropdown.setAttribute('aria-hidden', 'true');
        dropdownLinks.forEach(function (link) {
          link.setAttribute('tabindex', '-1');
        });
      }

      break;

    case KEY_NAMES.Enter:
      e.preventDefault();
      window.location.href = menuItem.getAttribute('href') || '';
      break;

    case KEY_NAMES.ArrowLeft:
      hideDropDown();
      dropdown.setAttribute('aria-hidden', 'true');
      dropdownLinks.forEach(function (link) {
        link.setAttribute('tabindex', '-1');
      });
      dropdownTrigger.parentElement.previousElementSibling.querySelector('a').focus();
      break;

    case KEY_NAMES.Escape:
    case KEY_NAMES.Esc:
    case KEY_NAMES.ArrowRight:
      e.preventDefault();
      hideDropDown();
      dropdown.setAttribute('aria-hidden', 'true');
      dropdownLinks.forEach(function (link) {
        link.setAttribute('tabindex', '-1');
      });
      dropdownTrigger.parentElement.nextElementSibling.querySelector('a').focus();
      break;

    case KEY_NAMES.ArrowUp:
      e.preventDefault();

      if (menuItem === firstItem) {
        lastItem.focus();
      } else {
        dropdownLinks[dropdownLinks.indexOf(menuItem) - 1].focus();
      }

      break;

    case KEY_NAMES.ArrowDown:
      e.preventDefault();

      if (menuItem === lastItem) {
        firstItem.focus();
      } else {
        dropdownLinks[dropdownLinks.indexOf(menuItem) + 1].focus();
      }

      break;
  }
}

var SET_SECURE_ACTION = 'SET_SECURE_ACTION';
var SET_LOGGED_OUT_ACTION = 'SET_LOGGED_OUT_ACTION';
var SET_LOGGED_IN_ACTION = 'SET_LOGGED_IN_ACTION';
var MY_ACCOUNT = 'My Account';
var SET_CUSTOMER_ID = 'SET_CUSTOMER_ID';
var SET_CREDIT_REPORT_STATUS = 'SET_CREDIT_REPORT_STATUS';
var SET_HAS_EVER_USED_NATIVE_APP = 'SET_HAS_EVER_USED_NATIVE_APP';

var HeaderLinkAnchor = styled.a.withConfig({
  displayName: "styled-components__HeaderLinkAnchor",
  componentId: "sc-16dqgk9-0"
})(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  white-space: nowrap;\n  cursor: pointer;\n  margin-right: ", ";\n  color: ", ";\n  width: 100%;\n  text-decoration: none;\n  padding: ", " ", ";\n  display: flex;\n  justify-content: space-between;\n\n  ", "\n  ", "\n  \n  &:focus {\n    ", "\n  }\n\n  &:hover {\n    color: ", ";\n  }\n\n  &.small_font {\n    ", "\n  }\n"], ["\n  white-space: nowrap;\n  cursor: pointer;\n  margin-right: ", ";\n  color: ", ";\n  width: 100%;\n  text-decoration: none;\n  padding: ", " ", ";\n  display: flex;\n  justify-content: space-between;\n\n  ", "\n  ", "\n  \n  &:focus {\n    ", "\n  }\n\n  &:hover {\n    color: ", ";\n  }\n\n  &.small_font {\n    ", "\n  }\n"])), function (_a) {
  var hasDropdown = _a.hasDropdown;
  return hasDropdown && 'auto';
}, function (props) {
  return props.variant === VARIANTS.loggedOut ? theme.indigo100 : '#fff';
}, theme.space15, theme.space20, theme.mediaMediumPlus(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme.space15, theme.space80), theme.mediaLargePlus(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n    padding: ", " 0;\n  "], ["\n    padding: ", " 0;\n  "])), theme.space20), focusStyles, function (props) {
  return props.variant === VARIANTS.loggedOut ? theme.indigo60 : '#fff';
}, theme.mediaLargePlus(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n      font-size: 14px;\n    "], ["\n      font-size: 14px;\n    "]))));
var NavUserInitials = styled.div.withConfig({
  displayName: "styled-components__NavUserInitials",
  componentId: "sc-16dqgk9-1"
})(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  font-size: 12px;\n  font-weight: 700;\n  color: ", ";\n  text-align: center;\n  top: -8px;\n  right: -42px;\n  background-color: #3de5b2;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  text-transform: capitalize;\n\n  ", "\n\n  ", "\n"], ["\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  font-size: 12px;\n  font-weight: 700;\n  color: ", ";\n  text-align: center;\n  top: -8px;\n  right: -42px;\n  background-color: #3de5b2;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  text-transform: capitalize;\n\n  ", "\n\n  ", "\n"])), theme.indigo100, theme.mediaMediumPlus(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n    width: 40px;\n    height: 40px;\n    top: initial;\n    right: 0;\n    font-size: 16px;\n  "], ["\n    width: 40px;\n    height: 40px;\n    top: initial;\n    right: 0;\n    font-size: 16px;\n  "]))), theme.mediaLargePlus(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n    width: 30px;\n    height: 30px;\n    position: absolute;\n    margin-right: -42px;\n    font-size: 12px;\n    margin-top: -15px;\n    top: 50%;\n  "], ["\n    width: 30px;\n    height: 30px;\n    position: absolute;\n    margin-right: -42px;\n    font-size: 12px;\n    margin-top: -15px;\n    top: 50%;\n  "]))));
var StyledChevronDownIcon = styled(ChevronDownIcon).withConfig({
  displayName: "styled-components__StyledChevronDownIcon",
  componentId: "sc-16dqgk9-2"
})(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject([""], [""])));
var StyledPersonalisedAccountWrapper = styled.span.withConfig({
  displayName: "styled-components__StyledPersonalisedAccountWrapper",
  componentId: "sc-16dqgk9-3"
})(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n  display: none;\n  ", "\n"], ["\n  display: none;\n  ", "\n"])), theme.mediaLargePlus(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n    display: inline;\n  "], ["\n    display: inline;\n  "]))));
var StyledMyAccountWrapper = styled.span.withConfig({
  displayName: "styled-components__StyledMyAccountWrapper",
  componentId: "sc-16dqgk9-4"
})(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n  display: inline;\n  ", "\n"], ["\n  display: inline;\n  ", "\n"])), theme.mediaLargePlus(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))));
var StyledChevronWrapper = styled(Box).withConfig({
  displayName: "styled-components__StyledChevronWrapper",
  componentId: "sc-16dqgk9-5"
})(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  &.my-account-chevron {\n    ", "\n  }\n"], ["\n  &.my-account-chevron {\n    ", "\n  }\n"])), theme.mediaLargePlus(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "]))));
var templateObject_1$g, templateObject_2$d, templateObject_3$a, templateObject_4$a, templateObject_5$9, templateObject_6$3, templateObject_7$3, templateObject_8$2, templateObject_9$2, templateObject_10$1, templateObject_11$1, templateObject_12$1, templateObject_13$1, templateObject_14;

var isBrowser$3 = typeof window !== 'undefined';
var BasinGlobalNavContext = /*#__PURE__*/createContext({});
var BasinGlobalNavProvider = function BasinGlobalNavProvider(_a) {
  var env = _a.env,
      children = _a.children;
  var environment = env === 'production' ? 'production' : 'staging';

  var _b = React.useState({}),
      contextValue = _b[0],
      setContextValue = _b[1];

  React.useEffect(function () {
    var _a, _b;

    if (isBrowser$3 && typeof XMLHttpRequest !== 'undefined') {
      if (!contextValue.GlobalNav) {
        var debug = ((_b = (_a = window.location) === null || _a === void 0 ? void 0 : _a.search) === null || _b === void 0 ? void 0 : _b.indexOf('debug')) > -1;
        setContextValue({
          GlobalNav: new Basin({
            channel: 'TotallyMoney',
            source: 'GlobalNav',
            environment: environment,
            debug: debug,
            metadata: {
              customerId: null
            }
          })
        });
      }
    }
  }, [contextValue, setContextValue]);
  return /*#__PURE__*/React.createElement(BasinGlobalNavContext.Provider, {
    value: contextValue
  }, children);
};

function useBasinGlobalNav() {
  return useContext(BasinGlobalNavContext);
}

var HeaderLink = function HeaderLink(_a) {
  var className = _a.className,
      href = _a.href,
      mobilemode = _a.mobilemode,
      children = _a.children,
      hasDropdown = _a.hasDropdown,
      isSubMenuOpen = _a.isSubMenuOpen,
      setIsMenuOpen = _a.setIsMenuOpen,
      setIsSubMenuOpen = _a.setIsSubMenuOpen,
      id = _a.id,
      iconTitle = _a.iconTitle;
  var context$1 = useContext(context);
  var basin = useBasinGlobalNav().GlobalNav;
  var renderLinksAs = context$1.renderLinksAs,
      state = context$1.state,
      objFocus = context$1.objFocus,
      setObjFocus = context$1.setObjFocus;

  var handleClick = function handleClick(e, title) {
    if (mobilemode && hasDropdown) {
      setIsSubMenuOpen(!isSubMenuOpen);
    }

    handleClickEvent(e.target.href, title, basin);

    if (mobilemode && !hasDropdown && setIsMenuOpen) {
      setIsMenuOpen(false);
    }

    if (mobilemode && hasDropdown) {
      setIsSubMenuOpen(!isSubMenuOpen);
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'KeyDown') {
      setObjFocus && setObjFocus(__assign(__assign({}, objFocus), {
        lastKeyDown: 'Tab',
        shiftKey: e.shiftKey
      }));
    } else {
      setObjFocus && setObjFocus(__assign(__assign({}, objFocus), {
        lastKeyDown: e.key,
        shiftKey: e.shiftKey
      }));
    }

    if (e.key === KEY_NAMES.Enter) {
      setIsSubMenuOpen(!isSubMenuOpen);
    }

    setPrimaryKeyboardControls(e, hasDropdown, e.key, objFocus.links);
  };

  var handleFocus = function handleFocus(e) {
    setObjFocus && setObjFocus(__assign(__assign({}, objFocus), {
      actFocus: e.target
    }));
    setPrimaryKeyboardControls(e, hasDropdown, objFocus.lastKeyDown, objFocus.links);
  };

  var renderChildren = function renderChildren() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children === MY_ACCOUNT ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledMyAccountWrapper, null, children), /*#__PURE__*/React.createElement(StyledPersonalisedAccountWrapper, null, state.customerName ? "Hi ".concat(startCase(state.customerName)) : startCase(children), /*#__PURE__*/React.createElement(NavUserInitials, {
      "data-testid": "tm-user-initials"
    }, state.customerInitials || ''))) : startCase(children), hasDropdown && /*#__PURE__*/React.createElement(StyledChevronWrapper, {
      display: "inline-flex",
      position: "relative",
      marginLeft: ['unset', 'unset', theme.space5],
      alignSelf: "center",
      "aria-hidden": "true",
      className: "".concat(className, " ").concat(children === MY_ACCOUNT ? 'my-account-chevron' : '')
    }, /*#__PURE__*/React.createElement(StyledChevronDownIcon, {
      size: 16,
      title: iconTitle,
      testID: "tm-menu-chevron",
      color: state.variant === 'loggedOut' ? theme.indigo100 : '#fff'
    })));
  };

  var renderHref = function renderHref() {
    if (mobilemode && hasDropdown) {
      return undefined;
    } else {
      return href;
    }
  };

  var propsObject = {
    className: "".concat(className, " ").concat(children === MY_ACCOUNT ? 'small_font' : ''),
    href: renderHref(),
    hasDropdown: hasDropdown,
    tabIndex: 0,
    id: mobilemode ? "link_".concat(id, "_mobile") : "link_".concat(id),
    onFocus: handleFocus,
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    },
    onClick: function onClick(e) {
      return handleClick(e, children);
    },
    role: 'menuitem'
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderLinksAs ? renderLinksAs( /*#__PURE__*/React.createElement(HeaderLinkAnchor, __assign({}, propsObject, {
    variant: state.variant
  }), renderChildren())) : /*#__PURE__*/React.createElement(HeaderLinkAnchor, __assign({}, propsObject, {
    variant: state.variant
  }), renderChildren()));
};

HeaderLink.defaultProps = {
  isSubMenuOpen: false,
  setIsSubMenuOpen: function setIsSubMenuOpen() {
    return null;
  },
  mobilemode: false,
  href: '',
  className: ''
};

var NavMenuItemWrapper = styled.li.withConfig({
  displayName: "styled-components__NavMenuItemWrapper",
  componentId: "sc-hmgd2l-0"
})(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  position: relative;\n  display: none;\n  margin: 0 22px;\n  transition: all 200ms;\n  & > div {\n    visibility: hidden;\n    opacity: 0;\n    transition: all 250ms ease;\n  }\n\n  &:hover > div,\n  .tm-nav__menu--dropdown-active {\n    visibility: visible;\n    opacity: 1;\n  }\n\n  &:hover,\n  & > div:hover {\n    svg {\n      transform: rotate(180deg);\n    }\n  }\n\n  ", "\n"], ["\n  position: relative;\n  display: none;\n  margin: 0 22px;\n  transition: all 200ms;\n  & > div {\n    visibility: hidden;\n    opacity: 0;\n    transition: all 250ms ease;\n  }\n\n  &:hover > div,\n  .tm-nav__menu--dropdown-active {\n    visibility: visible;\n    opacity: 1;\n  }\n\n  &:hover,\n  & > div:hover {\n    svg {\n      transform: rotate(180deg);\n    }\n  }\n\n  ", "\n"])), theme.mediaLargePlus(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n    display: inline;\n  "], ["\n    display: inline;\n  "]))));
var templateObject_1$f, templateObject_2$c;

var NavigationItem = function NavigationItem(_a) {
  var children = _a.children,
      menuLinkName = _a.menuLinkName,
      href = _a.href,
      style = _a.style,
      index = _a.index;
  var hasDropdown = (children === null || children === void 0 ? void 0 : children.props) !== undefined;
  return /*#__PURE__*/React.createElement(NavMenuItemWrapper, {
    style: style,
    role: "menuitem"
  }, /*#__PURE__*/React.createElement(HeaderLink, {
    className: "tm--header__menu-item tm-nav__menu--link ".concat(hasDropdown && 'has-dropdown'),
    href: href,
    hasDropdown: hasDropdown,
    mobilemode: false,
    id: index,
    iconTitle: "desktop-chevron-".concat(menuLinkName)
  }, menuLinkName), children && /*#__PURE__*/React.createElement("div", {
    className: "tm-dropDown"
  }, children));
};

NavigationItem.defaultProps = {
  children: undefined,
  href: 'https://www.totallymoney.com',
  style: null
};

var MobileNavWrapper = styled.nav.withConfig({
  displayName: "styled-components__MobileNavWrapper",
  componentId: "sc-ymmiat-0"
})(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  width: 100%;\n  position: absolute;\n  z-index: 4000;\n  display: flex;\n  left: 0;\n  top: ", ";\n  background-color: ", ";\n  transition: all 500ms ease-in-out;\n  padding-top: ", ";\n  padding-bottom: ", ";\n  color: ", "!important;\n\n  ", "\n\n  ", "\n"], ["\n  width: 100%;\n  position: absolute;\n  z-index: 4000;\n  display: flex;\n  left: 0;\n  top: ", ";\n  background-color: ", ";\n  transition: all 500ms ease-in-out;\n  padding-top: ", ";\n  padding-bottom: ", ";\n  color: ", "!important;\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.isOpen ? theme.space50 : '-999px';
}, function (props) {
  return props.variant === VARIANTS.loggedOut ? '#fff' : theme.indigo100;
}, theme.space20, theme.space20, function (props) {
  return props.variant === VARIANTS.loggedOut ? '#39374a' : '#fff';
}, theme.mediaMediumPlus(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n    top: ", ";\n  "], ["\n    top: ", ";\n  "])), function (props) {
  return props.isOpen ? theme.space80 : '-999px';
}), theme.mediaLargePlus(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))));
var MobileNavMenu = styled.ul.withConfig({
  displayName: "styled-components__MobileNavMenu",
  componentId: "sc-ymmiat-1"
})(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  font-family: ", ";\n  min-height: 100%;\n  width: 100%;\n"], ["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  font-family: ", ";\n  min-height: 100%;\n  width: 100%;\n"])), theme.buenosAires);
var SignUpMobileButtonWrapper = styled.li.withConfig({
  displayName: "styled-components__SignUpMobileButtonWrapper",
  componentId: "sc-ymmiat-2"
})(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  width: 100%;\n  margin-top: ", ";\n  padding: 0 ", ";\n\n  ", "\n"], ["\n  width: 100%;\n  margin-top: ", ";\n  padding: 0 ", ";\n\n  ", "\n"])), theme.space40, theme.space30, theme.mediaMediumPlus(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n    padding: 0 ", ";\n  "], ["\n    padding: 0 ", ";\n  "])), theme.space80));
styled.li.withConfig({
  displayName: "styled-components__AppDownloadIconsWrapper",
  componentId: "sc-ymmiat-3"
})(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  width: 100%;\n  padding: 0 ", ";\n\n  ", "\n"], ["\n  width: 100%;\n  padding: 0 ", ";\n\n  ", "\n"])), theme.space30, theme.mediaMediumPlus(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n    padding: 0 ", ";\n  "], ["\n    padding: 0 ", ";\n  "])), theme.space80));
var Hr = styled.hr.withConfig({
  displayName: "styled-components__Hr",
  componentId: "sc-ymmiat-4"
})(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  border: 0;\n  border-top: 1px solid\n    ", ";\n  margin-bottom: ", ";\n  margin-top: ", ";\n"], ["\n  border: 0;\n  border-top: 1px solid\n    ", ";\n  margin-bottom: ", ";\n  margin-top: ", ";\n"])), function (_a) {
  var variant = _a.variant;
  return variant === VARIANTS.loggedOut ? "rgba(204, 203, 212, 0.4)" : "rgba(255, 255, 255, 0.4)";
}, function (_a) {
  var mb = _a.mb;
  return mb || theme.space40;
}, function (_a) {
  var mt = _a.mt;
  return mt || theme.space40;
});
styled.li.withConfig({
  displayName: "styled-components__MyAccountTitle",
  componentId: "sc-ymmiat-5"
})(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  padding: 0 ", ";\n  width: 100%;\n  font-size: ", ";\n  color: rgba(255, 255, 255, 0.5);\n\n  ", "\n"], ["\n  padding: 0 ", ";\n  width: 100%;\n  font-size: ", ";\n  color: rgba(255, 255, 255, 0.5);\n\n  ", "\n"])), theme.space30, theme.space20, theme.mediaMediumPlus(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    padding: 0 ", ";\n  "], ["\n    padding: 0 ", ";\n  "])), theme.space80));
var StyledLinkButton$1 = styled(LinkButton).withConfig({
  displayName: "styled-components__StyledLinkButton",
  componentId: "sc-ymmiat-6"
})(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), theme.mediaMediumPlus(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    width: 270px;\n  "], ["\n    width: 270px;\n  "]))));
var templateObject_1$e, templateObject_2$b, templateObject_3$9, templateObject_4$9, templateObject_5$8, templateObject_6$2, templateObject_7$2, templateObject_8$1, templateObject_9$1, templateObject_10, templateObject_11, templateObject_12, templateObject_13;

var HeaderNav = styled.nav.withConfig({
  displayName: "styled-components__HeaderNav",
  componentId: "sc-sijwl7-0"
})(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  height: 100%;\n  width: auto;\n  flex: 2;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n\n  font-size: ", ";\n  opacity: 0;\n  transition: all 200ms ease;\n\n  &.show {\n    opacity: 1;\n  }\n"], ["\n  height: 100%;\n  width: auto;\n  flex: 2;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n\n  font-size: ", ";\n  opacity: 0;\n  transition: all 200ms ease;\n\n  &.show {\n    opacity: 1;\n  }\n"])), theme.space20);
var HeaderNavMenu = styled.ul.withConfig({
  displayName: "styled-components__HeaderNavMenu",
  componentId: "sc-sijwl7-1"
})(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex: 1 1 0;\n  height: 100%;\n\n  &.header__nav_loggedIn {\n    margin-right: 20px;\n  }\n"], ["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex: 1 1 0;\n  height: 100%;\n\n  &.header__nav_loggedIn {\n    margin-right: 20px;\n  }\n"])));
var LogInNavMenuItem = styled.li.withConfig({
  displayName: "styled-components__LogInNavMenuItem",
  componentId: "sc-sijwl7-2"
})(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var StyledLinkButton = styled(LinkButton).withConfig({
  displayName: "styled-components__StyledLinkButton",
  componentId: "sc-sijwl7-3"
})(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  min-height: unset;\n  height: 35px;\n  width: 82px;\n\n  ", "\n\n  &:active, &:focus {\n    display: flex !important;\n    border-radius: ", " !important;\n    align-items: center;\n\n    ", "\n  }\n"], ["\n  min-height: unset;\n  height: 35px;\n  width: 82px;\n\n  ", "\n\n  &:active, &:focus {\n    display: flex !important;\n    border-radius: ", " !important;\n    align-items: center;\n\n    ", "\n  }\n"])), theme.mediaMediumPlus(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n    height: 40px;\n    width: 126px;\n "], ["\n    height: 40px;\n    width: 126px;\n "]))), theme.borderRadiusXLarge, focusOutlineStyle);
var templateObject_1$d, templateObject_2$a, templateObject_3$8, templateObject_4$8, templateObject_5$7;

var HeaderNavMenuSub = styled(HeaderNavMenu).withConfig({
  displayName: "styled-components__HeaderNavMenuSub",
  componentId: "sc-17cmxms-0"
})(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  position: absolute;\n  flex-direction: column;\n  left: -24px;\n  top: ", "; /* distance of the menu title to the drop down*/\n  border-radius: 3px;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.15);\n  z-index: 9999;\n  width: 250px;\n\n  background-color: white;\n  align-items: flex-start;\n\n  padding: 0 ", ";\n\n  /* setting a fix width and aligness to drop down myAccount */\n  &.global-nav__dropdown--myaccount {\n    width: 170px;\n    text-align: right;\n  }\n\n  ", "\n"], ["\n  position: absolute;\n  flex-direction: column;\n  left: -24px;\n  top: ", "; /* distance of the menu title to the drop down*/\n  border-radius: 3px;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.15);\n  z-index: 9999;\n  width: 250px;\n\n  background-color: white;\n  align-items: flex-start;\n\n  padding: 0 ", ";\n\n  /* setting a fix width and aligness to drop down myAccount */\n  &.global-nav__dropdown--myaccount {\n    width: 170px;\n    text-align: right;\n  }\n\n  ", "\n"])), theme.space50, theme.space30, theme.mediaMediumPlus(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n    height: auto;\n    padding: ", ";\n  "], ["\n    height: auto;\n    padding: ", ";\n  "])), theme.space30));
var RenderLinkAnchor = styled.a.withConfig({
  displayName: "styled-components__RenderLinkAnchor",
  componentId: "sc-17cmxms-1"
})(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  display: block;\n  cursor: pointer;\n  text-decoration: none;\n  color: ", ";\n  line-height: 20px;\n\n  padding-left: ", ";\n  transition: all 300ms;\n\n  ", "\n\n  ", "\n\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  display: block;\n  cursor: pointer;\n  text-decoration: none;\n  color: ", ";\n  line-height: 20px;\n\n  padding-left: ", ";\n  transition: all 300ms;\n\n  ", "\n\n  ", "\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (props) {
  return props.variant === VARIANTS.loggedOut ? theme.indigo100 : '#fff';
}, theme.space40, theme.mediaMediumPlus(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  padding-top: 4px;\n  padding-bottom: 4px;\n    padding-left: ", ";\n  "], ["\n  padding-top: 4px;\n  padding-bottom: 4px;\n    padding-left: ", ";\n  "])), theme.space60), theme.mediaLargePlus(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n    color: ", ";\n    padding-left: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n  "], ["\n    color: ", ";\n    padding-left: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n  "])), theme.indigo100), theme.indigo60);
var MobileNavMenuSub = styled(MobileNavMenu).withConfig({
  displayName: "styled-components__MobileNavMenuSub",
  componentId: "sc-17cmxms-2"
})(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  left: 0;\n  z-index: 9999;\n  height: auto;\n  align-items: flex-start;\n\n  & > a {\n    width: 100%;\n  }\n\n  ", "\n"], ["\n  left: 0;\n  z-index: 9999;\n  height: auto;\n  align-items: flex-start;\n\n  & > a {\n    width: 100%;\n  }\n\n  ", "\n"])), theme.mediaMediumPlus(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme.space10, theme.space80));
var SubLinksItem = styled.li.withConfig({
  displayName: "styled-components__SubLinksItem",
  componentId: "sc-17cmxms-3"
})(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  padding-top: ", ";\n  padding-bottom: ", ";\n  width: 100%;\n\n  ", "\n  a:focus {\n    ", "\n  }\n"], ["\n  padding-top: ", ";\n  padding-bottom: ", ";\n  width: 100%;\n\n  ", "\n  a:focus {\n    ", "\n  }\n"])), theme.space10, theme.space10, theme.mediaLargePlus(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      margin: 4px 0;\n  "], ["\n      margin: 4px 0;\n  "]))), focusStyles);
var templateObject_1$c, templateObject_2$9, templateObject_3$7, templateObject_4$7, templateObject_5$6, templateObject_6$1, templateObject_7$1, templateObject_8, templateObject_9;

var RenderSubLinks = function RenderSubLinks(_a) {
  var _b, _c;

  var item = _a.item,
      isMobile = _a.isMobile;

  var _d = useContext(context),
      renderLinksAs = _d.renderLinksAs,
      state = _d.state;

  var basin = useBasinGlobalNav().GlobalNav;

  var handleKeyDown = function handleKeyDown(e) {
    setSecondaryKeyboardControls(e);
  };

  var renderHeaderLinks = function renderHeaderLinks(subItem, subIndex) {
    if (subItem.name === 'sign out') {
      return /*#__PURE__*/React.createElement(Box, {
        as: "li",
        key: subIndex,
        width: "100%",
        marginTop: theme.space20
      }, /*#__PURE__*/React.createElement(LinkButton, {
        variant: "tertiary",
        href: subItem.link,
        text: "Sign out"
      }));
    }

    var RenderLink = function RenderLink() {
      return /*#__PURE__*/React.createElement(RenderLinkAnchor, {
        variant: state.variant,
        href: subItem.link,
        onClick: function onClick(e) {
          return handleClickEvent(e.target.href, subItem.name, basin);
        },
        className: "sublink__item tm-nav__menu--dropdown-link",
        onKeyDown: handleKeyDown,
        tabIndex: -1
      }, subItem.name);
    };

    return /*#__PURE__*/React.createElement(SubLinksItem, {
      key: subIndex,
      className: "tm_sub-link-item",
      role: "menuitem"
    }, renderLinksAs ? renderLinksAs( /*#__PURE__*/React.createElement(RenderLink, null)) : /*#__PURE__*/React.createElement(RenderLink, null));
  };

  if (isMobile) {
    return /*#__PURE__*/React.createElement(MobileNavMenuSub, {
      "data-testid": "list-subitems",
      className: "sublink sublink__mobile-mode",
      role: "group"
    }, (_b = item.subLinks) === null || _b === void 0 ? void 0 : _b.map(function (subItem, subIndex) {
      return renderHeaderLinks(subItem, subIndex);
    }));
  } else {
    return /*#__PURE__*/React.createElement(HeaderNavMenuSub, {
      "data-testid": "list-subitems",
      className: "sublink sublink__desktop-mode ".concat(item.name.toLowerCase() === 'My Account'.toLowerCase() && 'global-nav__dropdown--myaccount')
    }, (_c = item.subLinks) === null || _c === void 0 ? void 0 : _c.map(function (subItem, subIndex) {
      return renderHeaderLinks(subItem, subIndex);
    }));
  }
};

RenderSubLinks.defaultProps = {
  item: {
    subLinks: []
  },
  isMobile: false,
  isSubMenuOpen: false
};

var CREDIT_REPORT_STATUS;

(function (CREDIT_REPORT_STATUS) {
  CREDIT_REPORT_STATUS["FOUND_BY_ALL_NEW_USER"] = "foundByAllNewUser";
  CREDIT_REPORT_STATUS["FOUND_BY_ALL_RETURNING_USER"] = "foundByAllReturningUser";
  CREDIT_REPORT_STATUS["KBA_OK_HD_NOT_FOUND"] = "KbaOkHdNotFound";
  CREDIT_REPORT_STATUS["NO_VNU_HD_FOUND"] = "NoVnuHdFound";
  CREDIT_REPORT_STATUS["NO_VNU_HD_NOT_FOUND"] = "NoVnuHdNotFound";
  CREDIT_REPORT_STATUS["ONBOARDING_REQUIRED_HD_FOUND"] = "onboardingRequiredHDFound";
  CREDIT_REPORT_STATUS["ONBOARDING_REQUIRED_HD_NOT_FOUND"] = "onboardingRequiredHDNotFound";
  CREDIT_REPORT_STATUS["KBA_REQUIRED_HD_FOUND"] = "KBARequiredHDFound";
  CREDIT_REPORT_STATUS["KBA_REQUIRED_HD_NOT_FOUND"] = "KBARequiredHDNotFound";
  CREDIT_REPORT_STATUS["KBA_FAILED_HD_FOUND"] = "KBAFailedHDFound";
  CREDIT_REPORT_STATUS["KBA_FAILED_HD_NOT_FOUND"] = "KBAFailedHDNotFound";
  CREDIT_REPORT_STATUS["KBA_BLOCKED_HD_FOUND"] = "KBABlockedHDFound";
  CREDIT_REPORT_STATUS["KBA_BLOCKED_HD_NOT_FOUND"] = "KBABlockedNotFoundHD";
  CREDIT_REPORT_STATUS["KBA_UNBLOCKED_HD_FOUND"] = "KBAUnblockedHDFound";
  CREDIT_REPORT_STATUS["KBA_UNBLOCKED_HD_NOT_FOUND"] = "KBAUnblockedNotFoundHD";
  CREDIT_REPORT_STATUS["THIN_FILE_HD_FOUND"] = "thinFileHDFound";
  CREDIT_REPORT_STATUS["THIN_FILE_HD_NOT_FOUND"] = "thinFileNotFoundHD";
  CREDIT_REPORT_STATUS["THIN_FILE_UPGRADE_HD_FOUND"] = "thinFileUpgradeHDFound";
  CREDIT_REPORT_STATUS["THIN_FILE_UPGRADE_HD_NOT_FOUND"] = "thinFileUpgradeNotFoundHD";
})(CREDIT_REPORT_STATUS || (CREDIT_REPORT_STATUS = {}));

var loginDeepLink = '/myaccount/open-app';
var globalNavMenuLink = '/myaccount/open-app?origin=global-nav-menu';
var globalNavHeaderLink = '/myaccount/open-app?origin=global-nav-header';

var AppPromotionModal = function AppPromotionModal(_a) {
  var _b = _a.isOpen,
      isOpen = _b === void 0 ? false : _b,
      setIsOpen = _a.setIsOpen;
  var basin = useBasinGlobalNav().GlobalNav;

  var handleContinueToAppClick = function handleContinueToAppClick() {
    basin === null || basin === void 0 ? void 0 : basin.send('webToAppLoginRedirectModalClick', {
      url: window.location.href,
      type: 'app'
    });
    setIsOpen(false);
  };

  var handleContinueToWeb = function handleContinueToWeb() {
    basin === null || basin === void 0 ? void 0 : basin.send('webToAppLoginRedirectModalClick', {
      url: window.location.href,
      type: 'web'
    });
    setIsOpen(false);
  };

  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: totallyMoneyTheme
  }, /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    hasHeader: false
  }, /*#__PURE__*/React.createElement(Box, {
    mt: theme.space10,
    mb: theme.space20,
    display: "flex",
    justifyContent: ['flex-start', 'center']
  }, /*#__PURE__*/React.createElement(Heading, {
    variant: "80"
  }, "Get more on the app")), /*#__PURE__*/React.createElement(Box, {
    mb: theme.space40,
    display: "flex",
    justifyContent: ['flex-start', 'center']
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "100"
  }, "Use the app for a better experience, including exclusive features.")), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    mb: theme.space30,
    width: "100%",
    maxWidth: "327px"
  }, /*#__PURE__*/React.createElement(LinkButton, {
    variant: "primary",
    text: "Open app",
    "aria-label": "Open app",
    href: loginDeepLink,
    onClick: handleContinueToAppClick
  }))), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    mb: theme.space10
  }, /*#__PURE__*/React.createElement(Anchor, {
    href: "/myaccount/login?exclude_from_promotion=true",
    onClick: handleContinueToWeb,
    "aria-label": "Continue on web"
  }, "Continue on web"))));
};

var hasCreditReport = function hasCreditReport(creditReportStatus) {
  if (creditReportStatus === CREDIT_REPORT_STATUS.KBA_OK_HD_NOT_FOUND || creditReportStatus === CREDIT_REPORT_STATUS.FOUND_BY_ALL_RETURNING_USER || creditReportStatus === CREDIT_REPORT_STATUS.FOUND_BY_ALL_NEW_USER) {
    return true;
  }

  return false;
};
var isThinFile = function isThinFile(creditReportStatus) {
  if (creditReportStatus === CREDIT_REPORT_STATUS.THIN_FILE_HD_FOUND || creditReportStatus === CREDIT_REPORT_STATUS.THIN_FILE_HD_NOT_FOUND) {
    return true;
  }

  return false;
};

var getLinks = function getLinks(state, customerId, creditReportStatus, isMobile) {
  if (state === VARIANTS.loggedOut) {
    return [{
      name: 'Credit Report',
      link: '/free-credit-report/',
      subLinks: []
    }, {
      name: 'Credit Cards',
      link: '/credit-cards/',
      subLinks: [{
        name: 'Cards for Poor Credit',
        link: '/credit-cards/credit-cards-bad-credit/'
      }, {
        name: 'Balance Transfer',
        link: '/credit-cards/balance-transfer/'
      }, {
        name: '0% Purchase',
        link: '/credit-cards/purchase/'
      }, {
        name: 'Cashback',
        link: '/credit-cards/cashback/'
      }, {
        name: 'Rewards',
        link: '/credit-cards/rewards/'
      }, {
        name: 'Balance Transfer & Purchase',
        link: '/credit-cards/0-percent/'
      }, {
        name: 'Travel',
        link: '/credit-cards/travel/'
      }, {
        name: 'All Credit Cards',
        link: '/credit-cards/'
      }]
    }, {
      name: 'Loans',
      link: '/loans/',
      subLinks: [{
        name: 'Personal Loans',
        link: '/loans/unsecured/'
      }, {
        name: 'Loans for Bad Credit',
        link: '/loans/bad-credit/'
      }, {
        name: 'Homeowner Loans',
        link: '/loans/homeowner/'
      }, {
        name: 'Car Finance Loans',
        link: '/loans/car-finance/'
      }, {
        name: 'All Loans',
        link: '/loans/'
      }]
    }, {
      name: 'mortgages',
      link: '/mortgages/',
      subLinks: [{
        name: 'Remortgage',
        link: '/mortgages/form/remortgage/'
      }, {
        name: 'First-Time Buyer',
        link: '/mortgages/form/firsttimebuyer/'
      }, {
        name: 'Buy-to-Let',
        link: '/mortgages/form/buytolet/'
      }, {
        name: 'Purchase',
        link: '/mortgages/form/purchase/'
      }, {
        name: 'All Mortgages',
        link: '/mortgages/'
      }]
    }];
  }

  return __spreadArray(__spreadArray(__spreadArray([{
    name: 'Home',
    link: '/myaccount/dashboard',
    subLinks: []
  }], isThinFile(creditReportStatus) ? [{
    name: 'Credit Report',
    link: '/myaccount/credit-report/get-your-full-report',
    subLinks: []
  }] : [], true), hasCreditReport(creditReportStatus) ? [{
    name: 'Credit Report',
    link: '/myaccount/credit-report',
    subLinks: [{
      name: 'Analysis',
      link: '/myaccount/credit-report'
    }, {
      name: 'Score History',
      link: '/myaccount/credit-report/score-history'
    }, {
      name: 'Accounts',
      link: '/myaccount/credit-report/accounts'
    }, {
      name: 'Profile',
      link: '/myaccount/credit-report/profile'
    }, {
      name: 'Searches',
      link: '/myaccount/credit-report/searches'
    }, {
      name: 'Rulings',
      link: '/myaccount/credit-report/rulings'
    }]
  }] : [], true), [{
    name: 'Offers',
    link: '/myaccount/offers',
    subLinks: []
  }, {
    name: 'Energy',
    link: '/energy/landing/',
    subLinks: []
  }, {
    name: 'Car Insurance',
    link: '/car-insurance',
    subLinks: []
  }, __assign({
    name: 'My Account',
    link: '/myaccount/dashboard'
  }, isMobile ? {
    subLinks: [{
      name: 'My Details',
      link: '/myaccount/details'
    }, {
      name: 'My Preferences',
      link: "/myaccount/preferences/email/".concat(customerId)
    }]
  } : {
    subLinks: [{
      name: 'My Details',
      link: '/myaccount/details'
    }, {
      name: 'My Preferences',
      link: "/myaccount/preferences/email/".concat(customerId)
    }, {
      name: 'Help',
      link: 'https://help.totallymoney.com/en/'
    }, {
      name: 'Guides',
      link: "/guides"
    }, {
      name: 'Sign Out',
      link: '/myaccount/logout'
    }]
  })]);
};

var DesktopNavigation$1 = function DesktopNavigation() {
  var _a = useState(false),
      appPromotionModalIsVisible = _a[0],
      setAppPromotionModalIsVisible = _a[1];

  var _b = useState(false),
      canShowAppPromo = _b[0],
      setCanShowPromo = _b[1];

  var HeaderNavRef = useRef(null);
  var context$1 = React.useContext(context);
  var state = context$1.state;
  var basin = useBasinGlobalNav().GlobalNav;
  useEffect(function () {
    if (state.variant) {
      HeaderNavRef.current.classList.add('show');
    }
  }, [state.variant]); // Handle modal click. We want this to have a time delay so that the browser has time to redirect to the app.
  // Should the customer then return the nav bar will then be showing this modal.

  var handleLoginDelayedModalClick = function handleLoginDelayedModalClick() {
    setTimeout(function () {
      setAppPromotionModalIsVisible(true);
    }, 2000);
  };

  var handleLoginClick = function handleLoginClick(e) {
    handleClickEvent(e.currentTarget.href, 'Log in', basin);
    handleLoginDelayedModalClick();
  };

  var loggedOutLinks = getLinks(VARIANTS.loggedOut);
  var loggedInLinks = getLinks(VARIANTS.loggedIn, state.customerId, state.creditReportStatus); // Only show AppPromo if on mobile or tablet.

  useEffect(function () {
    if (typeof window !== 'undefined') {
      var isNotDesktop = window === null || window === void 0 ? void 0 : window.matchMedia("(max-width: ".concat(theme.small, "px)")).matches;
      return setCanShowPromo(isNotDesktop);
    } else {
      return setCanShowPromo(false);
    }
  }, []);
  return /*#__PURE__*/React.createElement(HeaderNav, {
    className: "tm--header__nav",
    "data-testid": "tm--header__nav",
    "aria-label": "Totallymoney Navigation bar",
    ref: HeaderNavRef
  }, /*#__PURE__*/React.createElement(HeaderNavMenu, {
    role: "menu",
    className: state.variant === VARIANTS.loggedOut ? 'header__nav_loggedOut' : 'header__nav_loggedIn'
  }, state.variant === VARIANTS.loggedOut && /*#__PURE__*/React.createElement(React.Fragment, null, loggedOutLinks.map(function (item, index) {
    return /*#__PURE__*/React.createElement(NavigationItem, {
      href: item.link,
      menuLinkName: item.name,
      key: index,
      index: index
    }, item.subLinks.length > 0 ? /*#__PURE__*/React.createElement(RenderSubLinks, {
      item: item
    }) : undefined);
  }), /*#__PURE__*/React.createElement(NavigationItem, {
    href: "/myaccount/register",
    menuLinkName: "Sign Up",
    style: {
      marginLeft: '14px'
    },
    index: 4
  }), /*#__PURE__*/React.createElement(LogInNavMenuItem, {
    role: "menuitem"
  }, /*#__PURE__*/React.createElement(StyledLinkButton, {
    href: canShowAppPromo ? loginDeepLink : '/myaccount/login/',
    text: "Log in",
    variant: "tertiary",
    onClick: function onClick(e) {
      return handleLoginClick(e);
    },
    "data-testid": "login-button"
  }))), state.variant === VARIANTS.loggedIn && loggedInLinks.map(function (item, index) {
    return /*#__PURE__*/React.createElement(NavigationItem, {
      href: item.link,
      menuLinkName: item.name,
      key: index,
      index: index
    }, item.subLinks.length > 0 ? /*#__PURE__*/React.createElement(RenderSubLinks, {
      item: item
    }) : undefined);
  }), state.variant === VARIANTS.secure && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(PadlockIcon, {
    title: "padlock",
    color: "#FFFFFF",
    size: 18
  }))), canShowAppPromo ? /*#__PURE__*/React.createElement(AppPromotionModal, {
    isOpen: appPromotionModalIsVisible,
    setIsOpen: setAppPromotionModalIsVisible
  }) : null);
};

var MobileMenuItemWrapper = styled.li.withConfig({
  displayName: "styled-components__MobileMenuItemWrapper",
  componentId: "sc-1c5vlbp-0"
})(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  font-family: inherit;\n  font-size: 22px;\n  padding: 0;\n  transition: all 400ms;\n  background-color: ", ";\n\n  & > ul {\n    height: 0;\n    transition: all 250ms ease;\n  }\n\n  & svg {\n    transform: ", ";\n    transition: all 100ms;\n  }\n\n  & > a {\n    transition: all 150ms;\n    color: ", ";\n"], ["\n  position: relative;\n  width: 100%;\n  font-family: inherit;\n  font-size: 22px;\n  padding: 0;\n  transition: all 400ms;\n  background-color: ", ";\n\n  & > ul {\n    height: 0;\n    transition: all 250ms ease;\n  }\n\n  & svg {\n    transform: ", ";\n    transition: all 100ms;\n  }\n\n  & > a {\n    transition: all 150ms;\n    color: ", ";\n"])), function (props) {
  return props.isSubMenuOpen ? function (props) {
    return props.variant === VARIANTS.loggedOut ? theme.neutral80 : theme.indigo80;
  } : 'inherit';
}, function (props) {
  return props.isSubMenuOpen ? 'rotate(180deg)' : '';
}, function (props) {
  return props.variant === VARIANTS.loggedOut ? props.isSubMenuOpen ? '#bcb5b3' : theme.indigo100 : '#fff';
});
var MobileDropDownContainer = styled.div.withConfig({
  displayName: "styled-components__MobileDropDownContainer",
  componentId: "sc-1c5vlbp-1"
})(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  display: block;\n  height: auto;\n  max-height: ", ";\n  transition: all 300ms;\n  overflow: hidden;\n\n  ul {\n    padding-bottom: ", ";\n  }\n\n  li {\n    padding: 0;\n    font-size: 16px;\n  }\n\n  li a {\n    padding: ", " 0 ", " ", ";\n  }\n"], ["\n  display: block;\n  height: auto;\n  max-height: ", ";\n  transition: all 300ms;\n  overflow: hidden;\n\n  ul {\n    padding-bottom: ", ";\n  }\n\n  li {\n    padding: 0;\n    font-size: 16px;\n  }\n\n  li a {\n    padding: ", " 0 ", " ", ";\n  }\n"])), function (props) {
  return props.isSubMenuOpen ? '600px' : '0px';
}, theme.space15, theme.space15, theme.space15, theme.space40);
var templateObject_1$b, templateObject_2$8;

var MobileNavigationItem = function MobileNavigationItem(_a) {
  var children = _a.children,
      href = _a.href,
      isMenuOpen = _a.isMenuOpen,
      menuLinkName = _a.menuLinkName,
      index = _a.index,
      setIsMenuOpen = _a.setIsMenuOpen;

  var _b = React.useState(false),
      isSubMenuOpen = _b[0],
      setIsSubMenuOpen = _b[1];

  var context$1 = React.useContext(context);
  var hasDropdown = false;

  if (children) {
    hasDropdown = children.props !== undefined;
  }

  React.useEffect(function () {
    if (!isMenuOpen) {
      setIsSubMenuOpen(false);
    }
  }, [isMenuOpen]);
  return /*#__PURE__*/React.createElement(MobileMenuItemWrapper, {
    className: "tm_mobile-menu-item-wrapper",
    isSubMenuOpen: isSubMenuOpen,
    variant: context$1.state.variant,
    role: "none"
  }, /*#__PURE__*/React.createElement(HeaderLink, {
    href: href,
    className: "tm--header__menu-item",
    hasDropdown: hasDropdown,
    setIsSubMenuOpen: setIsSubMenuOpen,
    isSubMenuOpen: isSubMenuOpen,
    mobilemode: true,
    id: index,
    setIsMenuOpen: setIsMenuOpen,
    iconTitle: "mobile-chevron-".concat(menuLinkName)
  }, menuLinkName), hasDropdown && children ? /*#__PURE__*/React.createElement(MobileDropDownContainer, {
    isSubMenuOpen: isSubMenuOpen,
    "data-testid": "tm-dropdown-container",
    "aria-hidden": !isSubMenuOpen,
    role: "group"
  }, /*#__PURE__*/React.cloneElement(children, {
    isSubMenuOpen: isSubMenuOpen
  })) : null);
};

var Platform;

(function (Platform) {
  Platform["unknown"] = "unknown";
  Platform["ios"] = "ios";
  Platform["android"] = "android";
})(Platform || (Platform = {}));

var usePlatform = function usePlatform() {
  var _a = useState(),
      platform = _a[0],
      setPlatform = _a[1];

  useEffect(function () {
    var userAgent = navigator.userAgent;

    if (userAgent.match(/Android/i)) {
      setPlatform('android');
    } else if (userAgent.match(/iPhone|iPad|iPod/i)) {
      setPlatform('ios');
    } else {
      setPlatform('unknown');
    }
  }, []);
  return platform;
};

var MobileNavigationAppDownload = function MobileNavigationAppDownload() {
  var basin = useBasinGlobalNav().GlobalNav;
  var platform = usePlatform();

  if (!platform || platform === 'unknown') {
    return null;
  }

  return /*#__PURE__*/React.createElement(Box, {
    marginX: [theme.space20, theme.space80],
    display: ['block', 'block', 'block', 'none'],
    maxWidth: [343, 448, 448],
    role: "separator"
  }, /*#__PURE__*/React.createElement(Box, {
    borderRadius: theme.borderRadiusMedium,
    padding: theme.space20,
    backgroundColor: theme.indigo80,
    marginY: theme.space15,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Box, {
    mr: theme.space20
  }, /*#__PURE__*/React.createElement(Heading, {
    variant: "20",
    color: "white"
  }, "Get more in the TotallyMoney app")), /*#__PURE__*/React.createElement(Box, {
    display: "inline-flex",
    as: "a",
    href: globalNavMenuLink,
    "aria-label": "Get the TotallyMoney app on the ".concat(platform === 'ios' ? 'App Store' : 'Play Store'),
    // @ts-ignore
    onClick: function onClick(e) {
      return handleClickEvent(e.target.href, platform === 'ios' ? 'App Store Download' : 'Play Store Download', basin);
    }
  }, platform === 'ios' && /*#__PURE__*/React.createElement(AppStore, null), platform === 'android' && /*#__PURE__*/React.createElement(GooglePlay, null))));
};

var MobileNavigation = function MobileNavigation(_a) {
  var isMenuOpen = _a.isMenuOpen,
      setIsMenuOpen = _a.setIsMenuOpen;
  var context$1 = useContext(context);
  var basin = useBasinGlobalNav().GlobalNav;
  var state = context$1.state;
  var loggedOutLinks = getLinks(VARIANTS.loggedOut);
  var loggedInLinks = getLinks(VARIANTS.loggedIn, state.customerId, state.creditReportStatus, true);
  return /*#__PURE__*/React.createElement(MobileNavWrapper, {
    className: "tm--header-mobile__nav",
    isOpen: isMenuOpen,
    variant: state.variant
  }, /*#__PURE__*/React.createElement(MobileNavMenu, {
    id: "menu2",
    role: "menu",
    "aria-labelledby": "menubutton"
  }, state.variant === VARIANTS.loggedOut ? /*#__PURE__*/React.createElement(React.Fragment, null, loggedOutLinks.map(function (item, index) {
    return /*#__PURE__*/React.createElement(MobileNavigationItem, {
      href: item.link,
      menuLinkName: item.name,
      key: index,
      isMenuOpen: isMenuOpen,
      index: index
    }, item.subLinks.length > 0 ? /*#__PURE__*/React.createElement(RenderSubLinks, {
      item: item,
      isMobile: true
    }) : undefined);
  }), /*#__PURE__*/React.createElement(SignUpMobileButtonWrapper, {
    role: "none"
  }, /*#__PURE__*/React.createElement(Hr, {
    variant: state.variant,
    mt: "0"
  }), /*#__PURE__*/React.createElement(StyledLinkButton$1, {
    href: "/myaccount/register",
    text: "Sign up",
    variant: "secondaryOutline",
    onClick: function onClick(e) {
      return handleClickEvent(e.target.href, 'Sign Up', basin);
    }
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileNavigationItem, {
    href: "/myaccount/dashboard",
    menuLinkName: "Home",
    isMenuOpen: isMenuOpen,
    setIsMenuOpen: setIsMenuOpen,
    index: 0
  }), hasCreditReport(state.creditReportStatus) ? /*#__PURE__*/React.createElement(MobileNavigationItem, {
    menuLinkName: "Credit Report",
    isMenuOpen: isMenuOpen,
    index: 1,
    setIsMenuOpen: setIsMenuOpen
  }, /*#__PURE__*/React.createElement(RenderSubLinks, {
    item: loggedInLinks[1],
    isMobile: true
  })) : null, isThinFile(state.creditReportStatus) ? /*#__PURE__*/React.createElement(MobileNavigationItem, {
    href: "/myaccount/credit-report/get-your-full-report",
    menuLinkName: "Credit Report",
    isMenuOpen: isMenuOpen,
    index: 1,
    setIsMenuOpen: setIsMenuOpen
  }) : null, /*#__PURE__*/React.createElement(MobileNavigationItem, {
    href: "/myaccount/offers",
    menuLinkName: "Offers",
    isMenuOpen: isMenuOpen,
    index: 2,
    setIsMenuOpen: setIsMenuOpen
  }), /*#__PURE__*/React.createElement(MobileNavigationItem, {
    href: "/car-insurance",
    menuLinkName: "Car Insurance",
    isMenuOpen: isMenuOpen,
    index: 4,
    setIsMenuOpen: setIsMenuOpen
  }), /*#__PURE__*/React.createElement(MobileNavigationAppDownload, null), /*#__PURE__*/React.createElement(MobileNavigationItem, {
    menuLinkName: "My Account",
    isMenuOpen: isMenuOpen,
    index: 5,
    setIsMenuOpen: setIsMenuOpen
  }, /*#__PURE__*/React.createElement(RenderSubLinks, {
    item: loggedInLinks.find(function (item) {
      return item.name === 'My Account';
    }),
    isMobile: true
  })), /*#__PURE__*/React.createElement(MobileNavigationItem, {
    href: "https://help.totallymoney.com/en/",
    menuLinkName: "Help",
    isMenuOpen: isMenuOpen,
    index: 7,
    setIsMenuOpen: setIsMenuOpen
  }), /*#__PURE__*/React.createElement(MobileNavigationItem, {
    href: "/guides",
    menuLinkName: "Guides",
    isMenuOpen: isMenuOpen,
    index: 8,
    setIsMenuOpen: setIsMenuOpen
  }), /*#__PURE__*/React.createElement(MobileNavigationItem, {
    href: "/myaccount/logout",
    menuLinkName: "Sign out",
    isMenuOpen: isMenuOpen,
    index: 9,
    setIsMenuOpen: setIsMenuOpen
  }))));
};

MobileNavigation.defaultProps = {
  isMenuOpen: false
};

var SkipToContent = styled.a.withConfig({
  displayName: "styled-components__SkipToContent",
  componentId: "sc-1teicbc-0"
})(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background-color: ", ";\n  border-radius: 6px;\n  font-family: 'Buenos Aires';\n  padding: ", " ", ";\n  text-decoration: none;\n  color: ", ";\n  z-index: 9999;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 50px;\n  transform: translateY(-80px);\n\n  &:focus {\n    transform: translateY(60px);\n    outline: 1px solid rgba(255, 255, 255, 0);\n    box-shadow: 0 0 5px 0 ", ";\n  }\n  &:hover {\n    text-decoration: underline;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  background-color: ", ";\n  border-radius: 6px;\n  font-family: 'Buenos Aires';\n  padding: ", " ", ";\n  text-decoration: none;\n  color: ", ";\n  z-index: 9999;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 50px;\n  transform: translateY(-80px);\n\n  &:focus {\n    transform: translateY(60px);\n    outline: 1px solid rgba(255, 255, 255, 0);\n    box-shadow: 0 0 5px 0 ", ";\n  }\n  &:hover {\n    text-decoration: underline;\n  }\n"])), theme.teal60, theme.space10, theme.space20, theme.textColor, theme.teal60);
var templateObject_1$a;

var SkipToMain = function SkipToMain() {
  return /*#__PURE__*/React.createElement(SkipToContent, {
    className: "tm--skip-to-content",
    href: "#start-of-content"
  }, "Skip to main content");
};

var DesktopNavigationWrapper = styled.div.withConfig({
  displayName: "styled-components__DesktopNavigationWrapper",
  componentId: "sc-1b0nama-0"
})(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  width: 100%;\n  margin: 0 auto;\n  margin-bottom: -1px;\n  background-color: ", ";\n  border-bottom: 0.3pt solid rgba(0, 0, 0, 0.2);\n\n  * {\n    box-sizing: border-box;\n  }\n\n  box-sizing: border-box;\n  height: 50px;\n  position: relative;\n  z-index: 6000;\n  padding: 0 ", ";\n  -webkit-font-smoothing: antialiased;\n  transition: all 150ms;\n  padding: 0 ", ";\n\n  ", "\n\n  ", "\n\n  & a:focus {\n    display: block;\n    ", ";\n    border-radius: ", ";\n  }\n"], ["\n  width: 100%;\n  margin: 0 auto;\n  margin-bottom: -1px;\n  background-color: ", ";\n  border-bottom: 0.3pt solid rgba(0, 0, 0, 0.2);\n\n  * {\n    box-sizing: border-box;\n  }\n\n  box-sizing: border-box;\n  height: 50px;\n  position: relative;\n  z-index: 6000;\n  padding: 0 ", ";\n  -webkit-font-smoothing: antialiased;\n  transition: all 150ms;\n  padding: 0 ", ";\n\n  ", "\n\n  ", "\n\n  & a:focus {\n    display: block;\n    ", ";\n    border-radius: ", ";\n  }\n"])), function (props) {
  return props.variant === 'loggedOut' ? '#fff' : theme.indigo100;
}, theme.space30, theme.space20, theme.mediaMediumPlus(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n    height: 64px;\n    padding: 0 ", ";\n  "], ["\n    height: 64px;\n    padding: 0 ", ";\n  "])), theme.space80), theme.mediaLargePlus(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "]))), focusOutlineStyle, theme.borderRadiusSmall);
var DesktopNavigation = styled.header.withConfig({
  displayName: "styled-components__DesktopNavigation",
  componentId: "sc-1b0nama-1"
})(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  font-family: ", ";\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  height: 100%;\n  display: flex;\n  align-items: center;\n"], ["\n  font-family: ", ";\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  height: 100%;\n  display: flex;\n  align-items: center;\n"])), theme.buenosAires);
var StartOfContent = styled.div.withConfig({
  displayName: "styled-components__StartOfContent",
  componentId: "sc-1b0nama-2"
})(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: 0;\n  overflow: hidden;\n  clip: rect(1px, 1px, 1px, 1px);\n\n  &:focus {\n    z-index: ", ";\n    width: auto;\n    height: auto;\n    clip: auto;\n  }\n"], ["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: 0;\n  overflow: hidden;\n  clip: rect(1px, 1px, 1px, 1px);\n\n  &:focus {\n    z-index: ", ";\n    width: auto;\n    height: auto;\n    clip: auto;\n  }\n"])), theme.zIndex90);
var templateObject_1$9, templateObject_2$7, templateObject_3$6, templateObject_4$6, templateObject_5$5;

var HeaderLogo = styled.a.withConfig({
  displayName: "styled-components__HeaderLogo",
  componentId: "sc-1ud0arb-0"
})(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  margin-top: 6px;\n  width: 120px;\n\n  ", "\n"], ["\n  margin-top: 6px;\n  width: 120px;\n\n  ", "\n"])), theme.mediaMediumPlus(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n    margin-top: ", ";\n    width: 132px;\n  "], ["\n    margin-top: ", ";\n    width: 132px;\n  "])), theme.space10));
var templateObject_1$8, templateObject_2$6;

var HeaderTmLogo = function HeaderTmLogo(_a) {
  var Variant = _a.Variant;
  var basin = useBasinGlobalNav().GlobalNav;
  var baseUrl = Variant === VARIANTS.loggedIn ? "/myaccount/dashboard" : '/';
  var ariaText = Variant === VARIANTS.loggedIn ? 'dashboard' : 'homepage';
  return /*#__PURE__*/React.createElement(HeaderLogo, {
    href: baseUrl,
    "aria-label": "link to ".concat(ariaText),
    onClick: function onClick() {
      return handleClickEvent(baseUrl, 'TotallyMoney Logo', basin);
    }
  }, /*#__PURE__*/React.createElement(TmLogo, {
    color: Variant === VARIANTS.loggedOut ? theme.indigo100 : '#fff'
  }));
};

var getCustomerInitials = function getCustomerInitials() {
  var cookies = populateCookies();

  if (cookies.CNAI) {
    return decodeURIComponent(cookies.CNAI).substr(decodeURIComponent(cookies.CNAI).indexOf(';') + 1);
  }

  return '';
};

var initialState = {
  variant: VARIANTS.loggedOut,
  customerId: '',
  customerName: '',
  customerInitials: '',
  creditReportStatus: '',
  hasEverUsedNativeApp: ''
};
var tmReducer = function tmReducer(state, action) {
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case SET_LOGGED_IN_ACTION:
      return __assign(__assign({}, state), {
        variant: VARIANTS.loggedIn,
        customerName: payload.CNAI !== 'undefined' ? decodeURIComponent(payload.CNAI).substr(0, decodeURIComponent(payload.CNAI).indexOf(';')) : 'My Account',
        customerInitials: getCustomerInitials()
      });

    case SET_LOGGED_OUT_ACTION:
      return __assign(__assign({}, state), {
        variant: VARIANTS.loggedOut
      });

    case SET_SECURE_ACTION:
      return __assign(__assign({}, state), {
        variant: VARIANTS.secure
      });

    case SET_CUSTOMER_ID:
      return __assign(__assign({}, state), {
        customerId: payload.customerId
      });

    case SET_CREDIT_REPORT_STATUS:
      return __assign(__assign({}, state), {
        creditReportStatus: payload.creditReportStatus
      });

    case SET_HAS_EVER_USED_NATIVE_APP:
      return __assign(__assign({}, state), {
        hasEverUsedNativeApp: payload.hasEverUsedNativeApp
      });

    default:
      throw new Error('Unexpected action on the navigation reducer');
  }
};

var StyledUserInitialsMobile = styled(NavUserInitials).withConfig({
  displayName: "styled-components__StyledUserInitialsMobile",
  componentId: "sc-13ce8sm-0"
})(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  top: calc(50% - 15px);\n  right: ", ";\n\n  right: ", ";\n  display: none;\n\n  ", "\n"], ["\n  top: calc(50% - 15px);\n  right: ", ";\n\n  right: ", ";\n  display: none;\n\n  ", "\n"])), theme.space80, theme.space30, theme.mediaLargePlus(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))));
var StyledAppPromoLinkMobile = styled.a.withConfig({
  displayName: "styled-components__StyledAppPromoLinkMobile",
  componentId: "sc-13ce8sm-1"
})(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  ", "\n  padding: 6px ", ";\n  font-size: 14px;\n  min-height: 0;\n  display: inline-block;\n  width: auto;\n\n  // Component library override\n  ", "\n\n  ", "\n"], ["\n  ", "\n  padding: 6px ", ";\n  font-size: 14px;\n  min-height: 0;\n  display: inline-block;\n  width: auto;\n\n  // Component library override\n  ", "\n\n  ", "\n"])), buttonStyles, theme.space20, theme.mediaMediumPlus(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n    padding: 6px ", ";\n  "], ["\n    padding: 6px ", ";\n  "])), theme.space20), theme.mediaLargePlus(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))));
var templateObject_1$7, templateObject_2$5, templateObject_3$5, templateObject_4$5, templateObject_5$4;

var RightCallToAction = function RightCallToAction(_a) {
  var customerInitials = _a.customerInitials,
      hasEverUsedNativeApp = _a.hasEverUsedNativeApp;
  var basin = useBasinGlobalNav().GlobalNav;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledUserInitialsMobile, {
    "data-testid": "tm-user-initials"
  }, customerInitials), /*#__PURE__*/React.createElement(StyledAppPromoLinkMobile, {
    variant: "tertiary",
    // @ts-ignore
    onClick: function onClick(e) {
      return handleClickEvent(e.target.href, hasEverUsedNativeApp === 'true' ? 'Open the app' : 'Get the app', basin);
    },
    href: globalNavHeaderLink
  }, hasEverUsedNativeApp === 'true' ? 'Open the app' : 'Get the app'));
};

var GlobalNavigation = function GlobalNavigation(_a) {
  var variant = _a.variant,
      environment = _a.environment,
      renderLinksAs = _a.renderLinksAs,
      customerInitials = _a.customerInitials,
      customerId = _a.customerId,
      creditReportStatus = _a.creditReportStatus,
      hasEverUsedNativeApp = _a.hasEverUsedNativeApp;

  var _b = React.useReducer(tmReducer, __assign(__assign({}, initialState), {
    variant: variant || initialState.variant,
    customerId: customerId || initialState.customerId,
    customerInitials: customerInitials || '',
    creditReportStatus: creditReportStatus !== null && creditReportStatus !== void 0 ? creditReportStatus : initialState.creditReportStatus,
    hasEverUsedNativeApp: hasEverUsedNativeApp !== null && hasEverUsedNativeApp !== void 0 ? hasEverUsedNativeApp : initialState.hasEverUsedNativeApp
  })),
      state = _b[0],
      dispatch = _b[1];

  var _c = React.useState(false),
      isMenuOpen = _c[0],
      setIsMenuOpen = _c[1];

  var _d = React.useState({}),
      cookies = _d[0],
      setCookies = _d[1];

  var _e = React.useState({}),
      objFocus = _e[0],
      setObjFocus = _e[1];

  React.useEffect(function () {
    var newVariant = getStateVariant();

    if (!variant && newVariant === VARIANTS.loggedIn && newVariant !== state.variant) {
      dispatch({
        type: SET_LOGGED_IN_ACTION,
        payload: cookies
      });
    }

    if (!variant && newVariant === VARIANTS.loggedOut && newVariant !== state.variant) {
      dispatch({
        type: SET_LOGGED_OUT_ACTION,
        payload: null
      });
    }

    if (variant === VARIANTS.loggedIn) {
      dispatch({
        type: SET_LOGGED_IN_ACTION,
        payload: cookies
      });
    }

    if (variant === VARIANTS.secure) {
      dispatch({
        type: SET_SECURE_ACTION,
        payload: null
      });
    }
  }, [variant, cookies]);
  React.useEffect(function () {
    var newCookies = populateCookies();

    if (JSON.stringify(cookies) !== JSON.stringify(newCookies) || cookies.PulseSessionToken !== newCookies.PulseSessionToken) {
      setCookies(__assign({}, newCookies));
    }
  }, [setCookies, cookies]);
  React.useEffect(function () {
    var updatedCustomerId = customerId || cookies.PulseCustomerId;

    if (updatedCustomerId && !state.customerId) {
      dispatch({
        type: SET_CUSTOMER_ID,
        payload: {
          customerId: updatedCustomerId
        }
      });
    }
  }, [customerId, cookies]);
  React.useEffect(function () {
    if (cookies.creditReportStatus || creditReportStatus) {
      dispatch({
        type: SET_CREDIT_REPORT_STATUS,
        payload: {
          creditReportStatus: cookies.creditReportStatus || creditReportStatus
        }
      });
    }
  }, [cookies.creditReportStatus, creditReportStatus]);
  React.useEffect(function () {
    if (cookies.hasEverUsedNativeApp || hasEverUsedNativeApp) {
      dispatch({
        type: SET_HAS_EVER_USED_NATIVE_APP,
        payload: {
          hasEverUsedNativeApp: cookies.hasEverUsedNativeApp || hasEverUsedNativeApp
        }
      });
    }
  }, [cookies.hasEverUsedNativeApp, hasEverUsedNativeApp]);
  React.useEffect(function () {
    setObjFocus(__assign(__assign({}, objFocus), {
      links: getAllItemsLinkMenu()
    }));
  }, [cookies]);

  var getAllItemsLinkMenu = function getAllItemsLinkMenu() {
    return [].slice.call(document.querySelectorAll('.tm-nav__menu--link'));
  };

  return /*#__PURE__*/React.createElement(BasinGlobalNavProvider, {
    env: environment
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SkipToMain, null), /*#__PURE__*/React.createElement(context.Provider, {
    value: {
      renderLinksAs: renderLinksAs,
      state: state,
      objFocus: objFocus,
      setObjFocus: setObjFocus,
      environment: environment
    }
  }, /*#__PURE__*/React.createElement(DesktopNavigationWrapper, {
    variant: state.variant,
    "data-testid": "global-navigation-desktop"
  }, /*#__PURE__*/React.createElement(DesktopNavigation, {
    className: "global-nav tm-nav"
  }, state.variant !== VARIANTS.secure && /*#__PURE__*/React.createElement(MobileHamburgerButton, {
    isMenuOpen: isMenuOpen,
    setIsMenuOpen: setIsMenuOpen,
    variant: state.variant
  }), /*#__PURE__*/React.createElement(HeaderTmLogo, {
    Variant: state.variant
  }), /*#__PURE__*/React.createElement(DesktopNavigation$1, null), state.variant === VARIANTS.loggedIn ? /*#__PURE__*/React.createElement(RightCallToAction, {
    customerInitials: state.customerInitials,
    hasEverUsedNativeApp: state.hasEverUsedNativeApp
  }) : null)), state.variant !== VARIANTS.secure && /*#__PURE__*/React.createElement(MobileNavigation, {
    isMenuOpen: isMenuOpen,
    setIsMenuOpen: setIsMenuOpen
  })), /*#__PURE__*/React.createElement(StartOfContent, {
    id: "start-of-content"
  })));
};

GlobalNavigation.defaultProps = {
  environment: 'production',
  renderLinksAs: null,
  hasCreditReport: false
};

var Wrapper$1 = styled.footer.withConfig({
  displayName: "styled-components__Wrapper",
  componentId: "sc-b67en3-0"
})(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  *,\n  &:before,\n  &:after {\n    box-sizing: border-box;\n  }\n  width: 100%;\n  padding: ", " 0;\n  background-color: ", ";\n  @media only screen and (min-width: 768px) {\n    padding: ", " 0;\n  }\n"], ["\n  *,\n  &:before,\n  &:after {\n    box-sizing: border-box;\n  }\n  width: 100%;\n  padding: ", " 0;\n  background-color: ", ";\n  @media only screen and (min-width: 768px) {\n    padding: ", " 0;\n  }\n"])), theme.space40, theme.neutral80, theme.space80);
var Grid = styled.div.withConfig({
  displayName: "styled-components__Grid",
  componentId: "sc-b67en3-1"
})(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  margin: 0 auto;\n  width: 100%;\n  padding: 0 ", ";\n\n  @media only screen and (min-width: 768px) {\n    display: grid;\n    max-width: ", ";\n    padding: 0 ", ";\n    grid-template-columns: 270px 1fr;\n  }\n"], ["\n  margin: 0 auto;\n  width: 100%;\n  padding: 0 ", ";\n\n  @media only screen and (min-width: 768px) {\n    display: grid;\n    max-width: ", ";\n    padding: 0 ", ";\n    grid-template-columns: 270px 1fr;\n  }\n"])), theme.space30, theme.maxContentWidth, theme.space80);
var GridRowWrapper = styled.div.withConfig({
  displayName: "styled-components__GridRowWrapper",
  componentId: "sc-b67en3-2"
})(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  grid-row: 1/1;\n"], ["\n  grid-row: 1/1;\n"])));
var Mission = styled(Text).withConfig({
  displayName: "styled-components__Mission",
  componentId: "sc-b67en3-3"
})(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  width: 270px;\n  height: 80px;\n  margin: ", " 0;\n"], ["\n  width: 270px;\n  height: 80px;\n  margin: ", " 0;\n"])), theme.space20);
var Divider = styled.hr.withConfig({
  displayName: "styled-components__Divider",
  componentId: "sc-b67en3-4"
})(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  margin: ", " 0;\n  border: none;\n  border-bottom: ", " solid 0.5px;\n  @media only screen and (min-width: 768px) {\n    margin-top: 0;\n    grid-row: 2/3;\n    grid-column: 1/13;\n  }\n"], ["\n  margin: ", " 0;\n  border: none;\n  border-bottom: ", " solid 0.5px;\n  @media only screen and (min-width: 768px) {\n    margin-top: 0;\n    grid-row: 2/3;\n    grid-column: 1/13;\n  }\n"])), theme.space50, theme.neutral120);
var templateObject_1$6, templateObject_2$4, templateObject_3$4, templateObject_4$4, templateObject_5$3;

var isBrowser$2 = typeof window !== 'undefined';
var BasinGlobalFooterContext = /*#__PURE__*/createContext({});
var BasinGlobalFooterProvider = function BasinGlobalFooterProvider(_a) {
  var env = _a.env,
      children = _a.children;
  var environment = env === 'production' ? 'production' : 'staging';

  var _b = React.useState({}),
      contextValue = _b[0],
      setContextValue = _b[1];

  React.useEffect(function () {
    var _a, _b;

    if (isBrowser$2 && typeof XMLHttpRequest !== 'undefined') {
      if (!contextValue.GlobalFooter) {
        var debug = ((_b = (_a = window.location) === null || _a === void 0 ? void 0 : _a.search) === null || _b === void 0 ? void 0 : _b.indexOf('debug')) > -1;
        setContextValue({
          GlobalFooter: new Basin({
            channel: 'TotallyMoney',
            source: 'GlobalFooter',
            environment: environment,
            debug: debug,
            metadata: {
              customerId: null
            }
          })
        });
      }
    }
  }, [contextValue, setContextValue]);
  return /*#__PURE__*/React.createElement(BasinGlobalFooterContext.Provider, {
    value: contextValue
  }, children);
};

function useBasinGlobalFooter() {
  return useContext(BasinGlobalFooterContext);
}

var isBrowser$1 = typeof window !== 'undefined';
var StyledAnchor = styled(Anchor).withConfig({
  displayName: "Link__StyledAnchor",
  componentId: "sc-xo04e3-0"
})(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  font-weight: normal;\n  &:focus {\n    border-radius: ", ";\n  }\n"], ["\n  font-weight: normal;\n  &:focus {\n    border-radius: ", ";\n  }\n"])), theme.borderRadiusSmall);

var Link = function Link(_a) {
  var href = _a.href,
      children = _a.children,
      title = _a.title,
      isExternal = _a.isExternal;
  var basin = useBasinGlobalFooter().GlobalFooter;

  var handleClick = function handleClick() {
    if (isBrowser$1) {
      basin === null || basin === void 0 ? void 0 : basin.send('Click', {
        referrer: document.referrer,
        url: window.location.href,
        destination: href,
        userAgent: navigator.userAgent
      });
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, isExternal ? /*#__PURE__*/React.createElement(StyledAnchor, {
    href: href,
    title: title,
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": "Links to ".concat(title, ", opens in a new tab"),
    onClick: handleClick
  }, children) : /*#__PURE__*/React.createElement(Anchor, {
    href: href,
    title: title,
    onClick: handleClick,
    style: {
      fontWeight: 'normal'
    }
  }, children));
};
var templateObject_1$5;

var LegalWrapper = styled.div.withConfig({
  displayName: "styled-components__LegalWrapper",
  componentId: "sc-19v96ze-0"
})(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  @media only screen and (min-width: 768px) {\n    grid-row: 3/3;\n    grid-column: 1/13;\n  }\n"], ["\n  @media only screen and (min-width: 768px) {\n    grid-row: 3/3;\n    grid-column: 1/13;\n  }\n"])));
var LegalText = styled(Text).withConfig({
  displayName: "styled-components__LegalText",
  componentId: "sc-19v96ze-1"
})(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  margin-bottom: ", ";\n  color: ", ";\n  a {\n    font-weight: normal;\n  }\n  b {\n    font-weight: bold;\n  }\n"], ["\n  margin-bottom: ", ";\n  color: ", ";\n  a {\n    font-weight: normal;\n  }\n  b {\n    font-weight: bold;\n  }\n"])), theme.space20, theme.neutral200);
var TransUnionOuterWrapper = styled.div.withConfig({
  displayName: "styled-components__TransUnionOuterWrapper",
  componentId: "sc-19v96ze-2"
})(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  @media only screen and (min-width: 768px) {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    justify-content: space-between;\n    p {\n      margin-bottom: 1px !important;\n    }\n  }\n"], ["\n  @media only screen and (min-width: 768px) {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    justify-content: space-between;\n    p {\n      margin-bottom: 1px !important;\n    }\n  }\n"])));
var TransUnionInnerWrapper = styled.div.withConfig({
  displayName: "styled-components__TransUnionInnerWrapper",
  componentId: "sc-19v96ze-3"
})(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  @media only screen and (min-width: 768px) {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    p {\n      margin-right: 4px;\n    }\n  }\n"], ["\n  @media only screen and (min-width: 768px) {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    p {\n      margin-right: 4px;\n    }\n  }\n"])));
var templateObject_1$4, templateObject_2$3, templateObject_3$3, templateObject_4$3;

var Legal = function Legal(_a) {
  var variant = _a.variant;

  if (variant === VARIANTS.debitCardPage) {
    return /*#__PURE__*/React.createElement(LegalWrapper, null, /*#__PURE__*/React.createElement(LegalText, {
      variant: "100"
    }, "TotallyMoney has partnered with Currensea to provide the TotallyMoney Debit Card. We get a commission from Currensea when you take out the card."), /*#__PURE__*/React.createElement(LegalText, {
      variant: "100"
    }, "TotallyMoney is owned and operated by TotallyMoney Limited which is registered in England and Wales (Company Registration Number 06205695). Registered Office: 5th Floor, Halo, Counterslip, Bristol, BS1 6AJ. Credit is available, subject to status, only to UK residents aged 18 or over."));
  }

  return /*#__PURE__*/React.createElement(LegalWrapper, null, /*#__PURE__*/React.createElement(LegalText, {
    variant: "100"
  }, /*#__PURE__*/React.createElement("b", null, "TotallyMoney is an independent credit broker, not a lender."), " Our comparison service works with most leading lenders, covering the majority of the market.", ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://help.totallymoney.com/en/articles/165239-how-do-you-make-money",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Though we may be paid a fee by lenders or brokers"), ' ', "this never influences how our products are ranked."), /*#__PURE__*/React.createElement(LegalText, {
    variant: "100"
  }, "We don't provide financial advice. Product information is obtained from independent sources and rates displayed may vary depending on your personal circumstances. While we make every effort to ensure that information is up to date, you should always confirm the terms of the offer with the product provider."), /*#__PURE__*/React.createElement(LegalText, {
    variant: "100"
  }, "TotallyMoney is owned and operated by TotallyMoney Limited which is registered in England and Wales (Company Registration Number 06205695). TotallyMoney Limited is an Appointed Representative of TM Connect Limited, which is registered in England and Wales (Company Registration Number 06967012) and authorised and regulated by the Financial Conduct Authority in respect of consumer credit related activities (FCA FRN: 511936). Registered Office: 5th Floor, Halo, Counterslip, Bristol, BS1 6AJ. Credit is available, subject to status, only to UK residents aged 18 or over."), variant === VARIANTS.loggedIn ? /*#__PURE__*/React.createElement(TransUnionOuterWrapper, null, /*#__PURE__*/React.createElement(LegalText, {
    variant: "100"
  }, "Financial Conduct Authority authorised and regulated."), /*#__PURE__*/React.createElement(TransUnionInnerWrapper, null, /*#__PURE__*/React.createElement(LegalText, {
    variant: "100"
  }, "Credit file data is provided by:"), /*#__PURE__*/React.createElement(TransUnion, null))) : null);
};

var SocialIconsWrapper = styled.ul.withConfig({
  displayName: "styled-components__SocialIconsWrapper",
  componentId: "sc-qtz1h3-0"
})(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  margin-bottom: ", ";\n"], ["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  margin-bottom: ", ";\n"])), theme.space30);
var SocialIconWrapper = styled.li.withConfig({
  displayName: "styled-components__SocialIconWrapper",
  componentId: "sc-qtz1h3-1"
})(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  display: inline-block;\n  margin-right: ", ";\n  &:last-of-type {\n    margin-right: 0;\n  }\n"], ["\n  display: inline-block;\n  margin-right: ", ";\n  &:last-of-type {\n    margin-right: 0;\n  }\n"])), theme.space40);
var AppDownloadIconsWrapper = styled.div.withConfig({
  displayName: "styled-components__AppDownloadIconsWrapper",
  componentId: "sc-qtz1h3-2"
})(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  display: grid;\n  grid-column-gap: ", ";\n  grid-template-columns: 115px 115px;\n  margin-bottom: ", ";\n"], ["\n  display: grid;\n  grid-column-gap: ", ";\n  grid-template-columns: 115px 115px;\n  margin-bottom: ", ";\n"])), theme.space20, theme.space40);
styled.span.withConfig({
  displayName: "styled-components__Icon",
  componentId: "sc-qtz1h3-3"
})(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n"], ["\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n"])));
styled.span.withConfig({
  displayName: "styled-components__AppDownloadIcon",
  componentId: "sc-qtz1h3-4"
})(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  display: inline-block;\n  width: 115px;\n  height: 40px;\n"], ["\n  display: inline-block;\n  width: 115px;\n  height: 40px;\n"])));
var templateObject_1$3, templateObject_2$2, templateObject_3$2, templateObject_4$2, templateObject_5$2;

var renderIcon = function renderIcon(platform) {
  switch (platform) {
    case PLATFORM_NAMES.Instagram:
      return /*#__PURE__*/React.createElement(Instagram, {
        size: 24
      });

    case PLATFORM_NAMES.LinkedIn:
      return /*#__PURE__*/React.createElement(LinkedIn, {
        size: 24
      });

    case PLATFORM_NAMES.TikTok:
      return /*#__PURE__*/React.createElement(TikTok, {
        size: 24
      });

    case PLATFORM_NAMES.YouTube:
      return /*#__PURE__*/React.createElement(YouTube, {
        size: 24
      });

    case PLATFORM_NAMES.AppStore:
      return /*#__PURE__*/React.createElement(AppStore, null);

    case PLATFORM_NAMES.GooglePlay:
      return /*#__PURE__*/React.createElement(GooglePlay, null);

    default:
      return null;
  }
};

var SocialIcon = function SocialIcon(_a) {
  var href = _a.href,
      platform = _a.platform;
  return /*#__PURE__*/React.createElement(SocialIconWrapper, null, /*#__PURE__*/React.createElement(Link, {
    href: href,
    title: platform,
    isExternal: true
  }, renderIcon(platform)));
};

var SocialIcons = function SocialIcons(_a) {
  var icons = _a.icons;
  return /*#__PURE__*/React.createElement(SocialIconsWrapper, null, icons.map(function (_a) {
    var href = _a.href,
        platform = _a.platform;
    return /*#__PURE__*/React.createElement(SocialIcon, {
      key: platform,
      href: href,
      platform: platform
    });
  }));
};
var AppDownloadIcons = function AppDownloadIcons(_a) {
  var icons = _a.icons;
  return /*#__PURE__*/React.createElement(AppDownloadIconsWrapper, null, icons.map(function (_a, i) {
    var href = _a.href,
        platform = _a.platform;
    return /*#__PURE__*/React.createElement(Box, {
      key: i
    }, platform === PLATFORM_NAMES.GooglePlay ? /*#__PURE__*/React.createElement(Box, {
      width: "135px",
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Link, {
      key: platform,
      href: href,
      title: "Google Play",
      isExternal: true
    }, renderIcon(platform))) : null, platform === PLATFORM_NAMES.AppStore ? /*#__PURE__*/React.createElement(Box, {
      width: "120px",
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Link, {
      key: platform,
      href: href,
      title: "App Store",
      isExternal: true
    }, renderIcon(platform))) : null);
  }));
};

var LoggedOutSectionsWrapper = styled.div.withConfig({
  displayName: "styled-components__LoggedOutSectionsWrapper",
  componentId: "sc-1j6hre3-0"
})(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-row: 2/4;\n  grid-column-gap: ", ";\n  grid-row-gap: ", ";\n  @media only screen and (min-width: 768px) {\n    grid-row: 1/1;\n    grid-column: 4/13;\n    justify-content: space-between;\n    grid-template-columns: 88px 88px 88px 88px;\n  }\n  @media only screen and (min-width: ", "px) {\n    grid-column-gap: 72px;\n  }\n  @media only screen and (min-width: 1152px) {\n    grid-column-gap: ", ";\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-row: 2/4;\n  grid-column-gap: ", ";\n  grid-row-gap: ", ";\n  @media only screen and (min-width: 768px) {\n    grid-row: 1/1;\n    grid-column: 4/13;\n    justify-content: space-between;\n    grid-template-columns: 88px 88px 88px 88px;\n  }\n  @media only screen and (min-width: ", "px) {\n    grid-column-gap: 72px;\n  }\n  @media only screen and (min-width: 1152px) {\n    grid-column-gap: ", ";\n  }\n"])), theme.space40, theme.space50, theme.medium, theme.space160);
var LoggedOutSection = styled.div.withConfig({
  displayName: "styled-components__LoggedOutSection",
  componentId: "sc-1j6hre3-1"
})(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject([""], [""])));
var LoggedOutSectionHeading = styled.h4.withConfig({
  displayName: "styled-components__LoggedOutSectionHeading",
  componentId: "sc-1j6hre3-2"
})(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  width: 108px;\n  height: 20px;\n  font-family: ", ";\n  font-size: 16px;\n  color: ", ";\n  margin: 0;\n"], ["\n  width: 108px;\n  height: 20px;\n  font-family: ", ";\n  font-size: 16px;\n  color: ", ";\n  margin: 0;\n"])), theme.buenosAires, theme.indigo120);
var LoggedOutSectionLinksWrapper = styled.ul.withConfig({
  displayName: "styled-components__LoggedOutSectionLinksWrapper",
  componentId: "sc-1j6hre3-3"
})(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n"], ["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n"])));
var LoggedOutSectionLinkWrapper = styled.li.withConfig({
  displayName: "styled-components__LoggedOutSectionLinkWrapper",
  componentId: "sc-1j6hre3-4"
})(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  &:not(:last-of-type) {\n    margin-bottom: 8px;\n  }\n\n  a {\n    width: 108px;\n    min-height: 40px;\n    line-height: 40px;\n    font-family: ", ";\n    font-size: 14px;\n    color: ", ";\n    text-decoration: none;\n    display: inline-block;\n    font-weight: bold !important;\n\n    @media only screen and (min-width: 768px) {\n      &:not(:last-of-type) {\n        margin-bottom: 0;\n      }\n    \n      width: 90px;\n    }\n  }\n"], ["\n  &:not(:last-of-type) {\n    margin-bottom: 8px;\n  }\n\n  a {\n    width: 108px;\n    min-height: 40px;\n    line-height: 40px;\n    font-family: ", ";\n    font-size: 14px;\n    color: ", ";\n    text-decoration: none;\n    display: inline-block;\n    font-weight: bold !important;\n\n    @media only screen and (min-width: 768px) {\n      &:not(:last-of-type) {\n        margin-bottom: 0;\n      }\n    \n      width: 90px;\n    }\n  }\n"])), theme.nunito, theme.indigo60);
var LoggedInLinksWrapper = styled.ul.withConfig({
  displayName: "styled-components__LoggedInLinksWrapper",
  componentId: "sc-1j6hre3-5"
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin: ", " 0 ", " 0;\n  padding: 0;\n  list-style: none;\n  @media only screen and (min-width: 768px) {\n    text-align: right;\n    margin-top: 0;\n  }\n"], ["\n  margin: ", " 0 ", " 0;\n  padding: 0;\n  list-style: none;\n  @media only screen and (min-width: 768px) {\n    text-align: right;\n    margin-top: 0;\n  }\n"])), theme.space10, theme.space40);
var LoggedInLinkWrapper = styled.li.withConfig({
  displayName: "styled-components__LoggedInLinkWrapper",
  componentId: "sc-1j6hre3-6"
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: inline-block;\n  &:not(:last-of-type) {\n    margin-right: 20px;\n  }\n  a {\n    width: 108px;\n    height: 20px;\n    font-family: ", ";\n    font-size: 14px;\n    color: ", ";\n    text-decoration: none;\n    @media only screen and (min-width: 768px) {\n      width: 80px;\n    }\n  }\n"], ["\n  display: inline-block;\n  &:not(:last-of-type) {\n    margin-right: 20px;\n  }\n  a {\n    width: 108px;\n    height: 20px;\n    font-family: ", ";\n    font-size: 14px;\n    color: ", ";\n    text-decoration: none;\n    @media only screen and (min-width: 768px) {\n      width: 80px;\n    }\n  }\n"])), theme.nunito, theme.indigo60);
var templateObject_1$2, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6, templateObject_7;

var LoggedOutSections = function LoggedOutSections(_a) {
  var sections = _a.sections;
  return /*#__PURE__*/React.createElement(LoggedOutSectionsWrapper, null, sections.map(function (section, idx) {
    var heading = section.heading,
        items = section.items;
    return /*#__PURE__*/React.createElement(LoggedOutSection, {
      key: idx
    }, /*#__PURE__*/React.createElement(Box, {
      mb: theme.space20
    }, /*#__PURE__*/React.createElement(LoggedOutSectionHeading, null, heading)), /*#__PURE__*/React.createElement(LoggedOutSectionLinksWrapper, null, items.map(function (_a) {
      var displayLabel = _a.displayLabel,
          label = _a.label,
          href = _a.href;
      return /*#__PURE__*/React.createElement(LoggedOutSectionLinkWrapper, {
        key: label
      }, /*#__PURE__*/React.createElement(Link, {
        href: href
      }, displayLabel || label));
    })));
  }));
};
var LoggedInLinks = function LoggedInLinks(_a) {
  var items = _a.items;
  return /*#__PURE__*/React.createElement(LoggedInLinksWrapper, null, items.map(function (_a) {
    var label = _a.label,
        href = _a.href;
    return /*#__PURE__*/React.createElement(LoggedInLinkWrapper, {
      key: label
    }, /*#__PURE__*/React.createElement(Link, {
      href: href,
      title: label,
      isExternal: label === 'Help' || label === 'Guides'
    }, label));
  }));
};

var SOCIAL_ICONS = [{
  platform: PLATFORM_NAMES.LinkedIn,
  href: 'https://uk.linkedin.com/company/totallymoney'
}, {
  platform: PLATFORM_NAMES.YouTube,
  href: 'https://www.youtube.com/channel/UCzT81m3neFD3QSqEwX0IAyg'
}, {
  platform: PLATFORM_NAMES.Instagram,
  href: 'https://www.instagram.com/totallymoney/'
}, {
  platform: PLATFORM_NAMES.TikTok,
  href: 'https://www.tiktok.com/@totallymoney'
}];
var APP_DOWNLOAD_ICONS = [{
  platform: PLATFORM_NAMES.AppStore,
  href: 'https://apps.apple.com/gb/app/totallymoney-credit-report/id1265080577'
}, {
  platform: PLATFORM_NAMES.GooglePlay,
  href: 'https://play.google.com/store/apps/details?id=com.totallymoney.account&hl=en_GB'
}];
var getFooterSections = function getFooterSections(domain) {
  return [{
    heading: SECTION_HEADINGS.Services,
    items: [{
      label: 'Credit Report',
      href: "".concat(domain, "/free-credit-report/")
    }, {
      label: 'Credit Cards',
      href: "".concat(domain, "/credit-cards/")
    }, {
      label: 'Loans',
      href: "".concat(domain, "/loans/")
    }, {
      label: 'Mortgages',
      href: "".concat(domain, "/mortgages/")
    }]
  }, {
    heading: SECTION_HEADINGS.Company,
    items: [{
      label: 'About Us',
      href: "".concat(domain, "/about-us/")
    }, {
      label: 'Careers',
      href: "".concat(domain, "/careers/")
    }, {
      label: 'Contact',
      href: "".concat(domain, "/info/contact/")
    }, {
      label: 'Complaints',
      href: "".concat(domain, "/info/complaints/")
    }]
  }, {
    heading: SECTION_HEADINGS.Guidance,
    items: [{
      label: 'FAQs',
      href: 'https://help.totallymoney.com/en/'
    }, {
      label: 'Guides',
      href: "".concat(domain, "/guides/")
    }, {
      label: 'Press',
      href: "".concat(domain, "/press-centre/")
    }]
  }, {
    heading: SECTION_HEADINGS.Legal,
    items: [{
      label: 'Privacy',
      href: "".concat(domain, "/info/privacy-policy/")
    }, {
      displayLabel: 'T&Cs',
      label: 'Terms & Conditions',
      href: "".concat(domain, "/info/terms/")
    }, {
      label: 'Cookies',
      href: "".concat(domain, "/info/cookie-policy/")
    }]
  }];
};
var getFooterLinks = function getFooterLinks(domain) {
  return [{
    label: 'Privacy',
    href: "".concat(domain, "/info/privacy-policy/")
  }, {
    label: 'T&Cs',
    href: "".concat(domain, "/info/terms/")
  }, {
    label: 'Cookies',
    href: "".concat(domain, "/info/cookie-policy/")
  }, {
    label: 'Help',
    href: 'https://help.totallymoney.com/en/'
  }, {
    label: 'Guides',
    href: "".concat(domain, "/guides/")
  }];
};

var Wrapper = styled.div.withConfig({
  displayName: "styled-components__Wrapper",
  componentId: "sc-qr0rfs-0"
})(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  *,\n  &::before,\n  &:after {\n    box-sizing: border-box;\n  }\n  width: 100%;\n  position: fixed;\n  bottom: 0;\n  background-color: ", ";\n  overflow-y: hidden;\n  transition-property: all;\n  transition-duration: 1s;\n  z-index: 999999;\n  padding: ", ";\n  max-height: ", ";\n"], ["\n  *,\n  &::before,\n  &:after {\n    box-sizing: border-box;\n  }\n  width: 100%;\n  position: fixed;\n  bottom: 0;\n  background-color: ", ";\n  overflow-y: hidden;\n  transition-property: all;\n  transition-duration: 1s;\n  z-index: 999999;\n  padding: ", ";\n  max-height: ", ";\n"])), theme.indigo80, function (_a) {
  var isVisible = _a.isVisible;
  return isVisible ? "".concat(theme.space40, " 0px") : '0px';
}, function (_a) {
  var isVisible = _a.isVisible;
  return isVisible ? '238px' : '0px';
});
var StyledGrid = styled(Grid$1).withConfig({
  displayName: "styled-components__StyledGrid",
  componentId: "sc-qr0rfs-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  @media screen and (min-width: 768px) {\n    align-items: center;\n  }\n"], ["\n  @media screen and (min-width: 768px) {\n    align-items: center;\n  }\n"])));
var StyledText = styled(Text).withConfig({
  displayName: "styled-components__StyledText",
  componentId: "sc-qr0rfs-2"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  grid-row: 1/2;\n  grid-column: 1/13;\n  text-align: center;\n  margin-bottom: ", ";\n  @media screen and (min-width: 768px) {\n    grid-row: 1/1;\n    grid-column: 1/7;\n    text-align: left;\n    margin-bottom: 0;\n    margin-right: ", ";\n  }\n  ", "\n"], ["\n  grid-row: 1/2;\n  grid-column: 1/13;\n  text-align: center;\n  margin-bottom: ", ";\n  @media screen and (min-width: 768px) {\n    grid-row: 1/1;\n    grid-column: 1/7;\n    text-align: left;\n    margin-bottom: 0;\n    margin-right: ", ";\n  }\n  ", "\n"])), theme.space30, theme.space20, theme.mediaLargePlus(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    grid-column: 1/8;\n    margin-right: 0;\n  "], ["\n    grid-column: 1/8;\n    margin-right: 0;\n  "]))));
var StyledButton = styled(Button).withConfig({
  displayName: "styled-components__StyledButton",
  componentId: "sc-qr0rfs-3"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  grid-row: 2/2;\n  grid-column: 1/13;\n  width: 100%;\n  max-width: 280px;\n  height: 48px;\n  margin: 0 auto;\n  @media screen and (min-width: 768px) {\n    grid-row: 1/1;\n    grid-column: 7/13;\n    width: 280px;\n    height: 48px;\n    margin: 0;\n    justify-self: right;\n  }\n"], ["\n  grid-row: 2/2;\n  grid-column: 1/13;\n  width: 100%;\n  max-width: 280px;\n  height: 48px;\n  margin: 0 auto;\n  @media screen and (min-width: 768px) {\n    grid-row: 1/1;\n    grid-column: 7/13;\n    width: 280px;\n    height: 48px;\n    margin: 0;\n    justify-self: right;\n  }\n"])));
var templateObject_1$1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

var createCookiesObject = function createCookiesObject() {
  var _a;

  var cookies = {};
  (_a = document === null || document === void 0 ? void 0 : document.cookie) === null || _a === void 0 ? void 0 : _a.split(";").forEach(function (item) {
    cookies[item.split("=")[0].trim()] = item.split("=")[1];
  });
  return cookies;
};

var COOKIE_NAMES = {
  LEGACY_COOKIE_CONSENT: 'cookieInformed',
  COOKIE_CONSENT: 'cookieNotified'
};

var CookieBanner = function CookieBanner() {
  var _a = useState(false),
      isVisible = _a[0],
      setIsVisible = _a[1];

  useEffect(function () {
    var cookies = createCookiesObject(); // delete legacy consent cookie

    document.cookie = "".concat(COOKIE_NAMES.LEGACY_COOKIE_CONSENT, "=; path=/; secure; expires=").concat(new Date());
    var timer = setTimeout(function () {
      // check if consent cookie has been set
      if (!cookies[COOKIE_NAMES.COOKIE_CONSENT]) {
        setIsVisible(true); // set consent cookie expiry date

        var cookieConsentExpiry = new Date(new Date().setFullYear(new Date().getFullYear() + 2)); // set consent cookie

        document.cookie = "".concat(COOKIE_NAMES.COOKIE_CONSENT, "=true; path=/; secure; expires=").concat(cookieConsentExpiry);
      }
    }, 1000);
    return function () {
      return clearTimeout(timer);
    };
  }, []);

  var handleAcceptCookieSettings = function handleAcceptCookieSettings() {
    setIsVisible(false);
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    isVisible: isVisible
  }, /*#__PURE__*/React.createElement(StyledGrid, null, /*#__PURE__*/React.createElement(StyledText, {
    color: "white"
  }, "We use cookies as described in our", ' ', /*#__PURE__*/React.createElement("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: "https://www.totallymoney.com/info/cookie-policy/"
  }, "Cookie Policy"), ". Continue browsing or click to accept."), /*#__PURE__*/React.createElement(StyledButton, {
    variant: "tertiary",
    onClick: handleAcceptCookieSettings
  }, "Accept")));
};

var ENVIRONMENTS = strEnum(['development', 'staging', 'preprod', 'production']);

var _a;

var _b;
var isBrowser = typeof window !== 'undefined';
var DOMAIN = (_a = {}, _a[ENVIRONMENTS.development] = isBrowser ? (_b = window.location) === null || _b === void 0 ? void 0 : _b.origin : '', _a[ENVIRONMENTS.staging] = 'https://stage.totallymoney.com', _a[ENVIRONMENTS.preprod] = 'https://preprod.totallymoney.com', _a[ENVIRONMENTS.production] = 'https://www.totallymoney.com', _a);

var useDomain = function useDomain(environment) {
  var _a = useState(''),
      domain = _a[0],
      setDomain = _a[1];

  var _b = useState(''),
      accountDomain = _b[0],
      setAccountDomain = _b[1];

  useEffect(function () {
    var _a, _b;

    switch (environment) {
      case ENVIRONMENTS.development:
      case ENVIRONMENTS.production:
        setDomain(DOMAIN[environment]);
        setAccountDomain(DOMAIN[environment]);
        break;

      case ENVIRONMENTS.staging:
        setDomain(DOMAIN.staging);
        setAccountDomain(DOMAIN.preprod);
        break;

      default:
        setDomain((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin);
        setAccountDomain((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.origin);
        break;
    }
  }, []);
  return {
    domain: domain,
    accountDomain: accountDomain
  };
};

var BasinMetadata = function BasinMetadata(_a) {
  var session = _a.session,
      defaultVariant = _a.defaultVariant,
      customerId = _a.customerId;
  var basin = useBasinGlobalFooter().GlobalFooter;
  var hasBasin = basin != null;
  useEffect(function () {
    if (!defaultVariant && session && customerId && hasBasin) {
      basin === null || basin === void 0 ? void 0 : basin.updateMetadata({
        customerId: customerId
      });
    }
  }, [session, hasBasin]);
  return null;
};

var LogoContainer = styled.div.withConfig({
  displayName: "GlobalFooter__LogoContainer",
  componentId: "sc-1epujlt-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 150px;\n"], ["\n  width: 150px;\n"])));

var GlobalFooter = function GlobalFooter(_a) {
  var defaultVariant = _a.defaultVariant,
      environment = _a.environment,
      domainOverride = _a.domainOverride,
      session = _a.session,
      securePaths = _a.securePaths,
      customerId = _a.customerId,
      disableCookieBanner = _a.disableCookieBanner;

  var _b = useState(VARIANTS.loggedOut),
      variant = _b[0],
      setVariant = _b[1];

  var domain = domainOverride || useDomain(environment).domain;
  useEffect(function () {
    var _a;

    if (defaultVariant) {
      setVariant(defaultVariant);
    } else {
      if (session) {
        setVariant(VARIANTS.loggedIn);
      } else {
        setVariant(VARIANTS.loggedOut);
      }
    }

    if (securePaths === null || securePaths === void 0 ? void 0 : securePaths.includes((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname)) {
      setVariant(VARIANTS.secure);
    }
  }, [session]);
  return /*#__PURE__*/React.createElement(BasinGlobalFooterProvider, {
    env: environment
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BasinMetadata, {
    customerId: customerId,
    defaultVariant: defaultVariant,
    session: session
  }), /*#__PURE__*/React.createElement(Wrapper$1, {
    "data-testid": variant
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(GridRowWrapper, null, /*#__PURE__*/React.createElement(LogoContainer, null, /*#__PURE__*/React.createElement(Link, {
    href: domain
  }, /*#__PURE__*/React.createElement(TotallyMoneyWithSymbol, null))), variant === VARIANTS.loggedOut && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Mission, {
    color: "light"
  }, "We're on a mission to help everyone move their finances forward and gain financial momentum."), /*#__PURE__*/React.createElement(SocialIcons, {
    icons: SOCIAL_ICONS
  }), /*#__PURE__*/React.createElement(AppDownloadIcons, {
    icons: APP_DOWNLOAD_ICONS
  }))), variant === VARIANTS.loggedOut ? /*#__PURE__*/React.createElement(LoggedOutSections, {
    sections: getFooterSections(domain)
  }) : /*#__PURE__*/React.createElement(LoggedInLinks, {
    items: getFooterLinks(domain)
  }), variant === VARIANTS.loggedOut && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Legal, {
    variant: variant
  }))), !disableCookieBanner ? /*#__PURE__*/React.createElement(CookieBanner, null) : null));
};
var templateObject_1;

export { CookieBanner as CookieBannerV2, GlobalFooter, GlobalNavigation, getCustomerInitials, getStateVariant };
//# sourceMappingURL=index.es.js.map
